var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 292,
    viewBox: "0 0 1440 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1576_69345)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M750.938 47.3742C750.938 48.5058 751.827 49.3949 752.958 49.3949C754.09 49.3949 754.979 48.5058 754.979 47.3742C754.979 46.2426 754.09 45.3535 752.958 45.3535C751.827 45.3535 750.938 46.2426 750.938 47.3742Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.07 237.401C736.07 238.533 736.959 239.422 738.091 239.422C739.223 239.422 740.112 238.533 740.112 237.401C740.112 236.27 739.223 235.381 738.091 235.381C736.959 235.381 736.07 236.27 736.07 237.401Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.922 201.918C826.922 202.645 827.488 203.211 828.215 203.211C828.943 203.211 829.508 202.645 829.508 201.918C829.508 201.19 828.943 200.624 828.215 200.624C827.568 200.624 826.922 201.271 826.922 201.918Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.492 166.596C598.492 167.323 599.058 167.889 599.785 167.889C600.513 167.889 601.079 167.323 601.079 166.596C601.079 165.868 600.513 165.303 599.785 165.303C599.139 165.303 598.492 165.868 598.492 166.596Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.805 36.624C701.805 37.7556 702.694 38.6447 703.825 38.6447C704.957 38.6447 705.846 37.7556 705.846 36.624C705.846 35.4924 704.957 34.6033 703.825 34.6033C702.694 34.6842 701.805 35.5733 701.805 36.624Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.883 84.7976C666.883 85.9292 667.772 86.8183 668.904 86.8183C670.035 86.8183 670.924 85.9292 670.924 84.7976C670.924 83.666 670.035 82.7769 668.904 82.7769C667.772 82.8577 666.883 83.7469 666.883 84.7976Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.703 68.7936C653.703 69.3594 654.188 69.8444 654.754 69.8444C655.32 69.8444 655.805 69.3594 655.805 68.7936C655.805 68.2278 655.32 67.7429 654.754 67.7429C654.188 67.7429 653.703 68.2278 653.703 68.7936Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.414 146.793C547.414 147.359 547.899 147.844 548.465 147.844C549.031 147.844 549.516 147.359 549.516 146.793C549.516 146.227 549.031 145.742 548.465 145.742C547.899 145.742 547.414 146.227 547.414 146.793Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.797 213.395C580.797 214.123 581.363 214.689 582.09 214.689C582.818 214.689 583.383 214.123 583.383 213.395C583.383 212.668 582.818 212.102 582.09 212.102C581.363 212.102 580.797 212.668 580.797 213.395Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.984 248.394C606.984 248.96 607.469 249.445 608.035 249.445C608.601 249.445 609.086 248.96 609.086 248.394C609.086 247.828 608.601 247.343 608.035 247.343C607.469 247.343 606.984 247.828 606.984 248.394Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.508 258.336C813.508 258.901 813.993 259.386 814.559 259.386C815.124 259.386 815.609 258.901 815.609 258.336C815.609 257.77 815.124 257.285 814.559 257.285C813.912 257.285 813.508 257.77 813.508 258.336Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.617 45.1918C879.617 45.7576 880.102 46.2426 880.668 46.2426C881.234 46.2426 881.719 45.7576 881.719 45.1918C881.719 44.626 881.234 44.1411 880.668 44.1411C880.102 44.1411 879.617 44.626 879.617 45.1918Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.055 238.371C801.055 238.937 801.54 239.422 802.105 239.422C802.671 239.422 803.156 238.937 803.156 238.371C803.156 237.805 802.671 237.32 802.105 237.32C801.54 237.32 801.055 237.805 801.055 238.371Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.445 243.14C772.445 243.706 772.93 244.191 773.496 244.191C774.062 244.191 774.547 243.706 774.547 243.14C774.547 242.574 774.062 242.089 773.496 242.089C772.93 242.089 772.445 242.494 772.445 243.14Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.648 237.482C878.648 238.614 879.538 239.422 880.588 239.422C881.72 239.422 882.528 238.533 882.528 237.482C882.528 236.351 881.639 235.542 880.588 235.542C879.538 235.461 878.648 236.351 878.648 237.482Z",
    fill: "#66ADE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.359 161.746C944.359 162.878 945.248 163.686 946.299 163.686C947.431 163.686 948.239 162.797 948.239 161.746C948.239 160.614 947.35 159.806 946.299 159.806C945.248 159.806 944.359 160.614 944.359 161.746Z",
    fill: "#435999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.727 251.708C905.727 252.839 906.616 253.648 907.666 253.648C908.798 253.648 909.606 252.759 909.606 251.708C909.606 250.576 908.717 249.768 907.666 249.768C906.616 249.768 905.727 250.657 905.727 251.708Z",
    fill: "#25346B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.262 172.496C480.645 174.598 483.07 177.023 485.171 175.406C486.788 173.304 484.363 170.88 482.262 172.496Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.211 92.8805C965.211 94.0121 966.1 94.8203 967.151 94.8203C968.282 94.8203 969.091 93.9312 969.091 92.8805C969.091 91.7489 968.202 90.9406 967.151 90.9406C966.1 90.8598 965.211 91.7489 965.211 92.8805Z",
    fill: "#1B275A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M749.078 290.101C749.078 290.667 749.563 291.152 750.129 291.152C750.695 291.152 751.18 290.667 751.18 290.101C751.18 289.535 750.695 289.051 750.129 289.051C749.482 289.051 749.078 289.535 749.078 290.101Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M724.43 281.614C724.43 282.18 724.915 282.665 725.48 282.665C726.046 282.665 726.531 282.18 726.531 281.614C726.531 281.048 726.046 280.563 725.48 280.563C724.915 280.644 724.43 281.048 724.43 281.614Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M659.203 271.672C659.203 272.238 659.688 272.723 660.254 272.723C660.82 272.723 661.305 272.238 661.305 271.672C661.305 271.107 660.82 270.622 660.254 270.622C659.688 270.702 659.203 271.107 659.203 271.672Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M635.594 249.93C635.594 250.495 636.079 250.98 636.645 250.98C637.21 250.98 637.695 250.495 637.695 249.93C637.695 249.364 637.21 248.879 636.645 248.879C636.079 248.96 635.594 249.364 635.594 249.93Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M823.68 227.864C823.68 228.429 824.165 228.914 824.73 228.914C825.296 228.914 825.781 228.429 825.781 227.864C825.781 227.298 825.296 226.813 824.73 226.813C824.165 226.813 823.68 227.298 823.68 227.864Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M807.844 133.618C807.844 134.184 808.329 134.669 808.895 134.669C809.46 134.669 809.945 134.184 809.945 133.618C809.945 133.052 809.46 132.567 808.895 132.567C808.248 132.567 807.844 133.052 807.844 133.618Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M812.445 183.974C812.445 184.54 812.93 185.025 813.496 185.025C814.062 185.025 814.547 184.54 814.547 183.974C814.547 183.408 814.062 182.923 813.496 182.923C812.93 182.923 812.445 183.408 812.445 183.974Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M847.609 208.465C847.609 209.031 848.094 209.516 848.66 209.516C849.226 209.516 849.711 209.031 849.711 208.465C849.711 207.899 849.226 207.414 848.66 207.414C848.094 207.414 847.609 207.899 847.609 208.465Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M619.43 214.769C619.43 215.335 619.915 215.82 620.48 215.82C621.046 215.82 621.531 215.335 621.531 214.769C621.531 214.204 621.046 213.719 620.48 213.719C619.915 213.719 619.43 214.204 619.43 214.769Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M655.477 143.156C655.477 143.721 655.962 144.206 656.527 144.206C657.093 144.206 657.578 143.721 657.578 143.156C657.578 142.59 657.093 142.105 656.527 142.105C655.962 142.186 655.477 142.59 655.477 143.156Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M636.648 87.6267C636.648 88.1925 637.133 88.6775 637.699 88.6775C638.265 88.6775 638.75 88.1925 638.75 87.6267C638.75 87.0609 638.265 86.5759 637.699 86.5759C637.133 86.5759 636.648 87.0609 636.648 87.6267Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M657.266 31.2085C657.266 31.7743 657.751 32.2593 658.316 32.2593C658.882 32.2593 659.367 31.7743 659.367 31.2085C659.367 30.6427 658.882 30.1577 658.316 30.1577C657.751 30.1577 657.266 30.6427 657.266 31.2085Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M717.562 1.94872C717.562 2.51452 718.047 2.99948 718.613 2.99948C719.179 2.99948 719.664 2.51452 719.664 1.94872C719.664 1.38292 719.179 0.897949 718.613 0.897949C718.047 0.978777 717.562 1.38292 717.562 1.94872Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M725.477 33.3101C725.477 33.8759 725.962 34.3609 726.527 34.3609C727.093 34.3609 727.578 33.8759 727.578 33.3101C727.578 32.7443 727.093 32.2593 726.527 32.2593C725.881 32.2593 725.477 32.7443 725.477 33.3101Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M676.094 29.107C676.094 29.6728 676.579 30.1578 677.145 30.1578C677.71 30.1578 678.195 29.6728 678.195 29.107C678.195 28.5412 677.71 28.0563 677.145 28.0563C676.579 28.1371 676.094 28.5412 676.094 29.107Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M742.211 16.4978C742.211 17.0636 742.696 17.5486 743.262 17.5486C743.827 17.5486 744.312 17.0636 744.312 16.4978C744.312 15.932 743.827 15.447 743.262 15.447C742.696 15.5278 742.211 15.932 742.211 16.4978Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M718.609 21.0242C718.609 21.59 719.094 22.075 719.66 22.075C720.226 22.075 720.711 21.59 720.711 21.0242C720.711 20.4584 720.226 19.9734 719.66 19.9734C719.094 19.9734 718.609 20.4584 718.609 21.0242Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M792.164 77.1998C792.164 77.7656 792.649 78.2506 793.215 78.2506C793.781 78.2506 794.266 77.7656 794.266 77.1998C794.266 76.634 793.781 76.149 793.215 76.149C792.649 76.2299 792.164 76.634 792.164 77.1998Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M779.953 268.682C779.953 269.813 780.842 270.622 781.893 270.622C783.025 270.622 783.833 269.732 783.833 268.682C783.833 267.55 782.944 266.742 781.893 266.742C780.842 266.742 779.953 267.631 779.953 268.682Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M698.234 288.08C698.234 289.212 699.123 290.02 700.174 290.02C701.306 290.02 702.114 289.131 702.114 288.08C702.114 286.949 701.225 286.141 700.174 286.141C699.123 286.141 698.234 287.03 698.234 288.08Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.352 79.5438C974.352 80.2713 974.917 80.837 975.645 80.837C976.372 80.837 976.938 80.2713 976.938 79.5438C976.938 78.8164 976.372 78.2505 975.645 78.2505C974.917 78.3314 974.352 78.8972 974.352 79.5438Z",
    fill: "#1B275A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.125 83.9894C546.125 85.2826 547.176 86.3334 548.469 86.3334C549.762 86.3334 550.813 85.2826 550.813 83.9894C550.813 82.6961 549.762 81.6453 548.469 81.6453C547.176 81.6453 546.125 82.6961 546.125 83.9894Z",
    fill: "#8EE1F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.227 169.021C626.227 169.586 626.712 170.071 627.277 170.071C627.843 170.071 628.328 169.586 628.328 169.021C628.328 168.455 627.843 167.97 627.277 167.97C626.712 168.051 626.227 168.455 626.227 169.021Z",
    fill: "#ADEDF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.555 132.001C623.555 132.567 624.04 133.052 624.605 133.052C625.171 133.052 625.656 132.567 625.656 132.001C625.656 131.436 625.171 130.951 624.605 130.951C624.04 130.951 623.555 131.436 623.555 132.001Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.098 185.025C590.663 185.025 591.148 184.54 591.148 183.974C591.148 183.408 590.663 182.923 590.098 182.923C589.532 182.923 589.047 183.408 589.047 183.974C589.047 184.54 589.532 185.025 590.098 185.025Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.016 31.6935C590.016 32.0168 590.258 32.2593 590.581 32.2593C590.905 32.2593 591.147 32.0168 591.147 31.6935C591.147 31.3702 590.905 31.1277 590.581 31.1277C590.258 31.2085 590.016 31.451 590.016 31.6935Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.188 197.634C923.188 197.876 923.43 198.119 923.672 198.119C923.915 198.119 924.157 197.876 924.157 197.634C924.157 197.391 923.915 197.149 923.672 197.149C923.43 197.149 923.188 197.391 923.188 197.634Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.836 43.1711C670.836 43.4945 671.078 43.7369 671.402 43.7369C671.725 43.7369 671.968 43.4945 671.968 43.1711C671.968 42.8478 671.725 42.6053 671.402 42.6053C671.078 42.6053 670.836 42.8478 670.836 43.1711Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.531 216.386C656.531 216.709 656.774 216.952 657.097 216.952C657.42 216.952 657.663 216.709 657.663 216.386C657.663 216.063 657.42 215.82 657.097 215.82C656.774 215.82 656.531 216.063 656.531 216.386Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.016 164.413C657.016 164.737 657.258 164.979 657.581 164.979C657.905 164.979 658.147 164.737 658.147 164.413C658.147 164.09 657.905 163.848 657.581 163.848C657.258 163.848 657.016 164.09 657.016 164.413Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M539.656 207.98C539.656 208.869 540.384 209.596 541.273 209.596C542.162 209.596 542.889 208.869 542.889 207.98C542.889 207.091 542.162 206.363 541.273 206.363C540.384 206.444 539.656 207.091 539.656 207.98Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.742 165.383C485.742 165.949 486.227 166.434 486.793 166.434C487.359 166.434 487.844 165.949 487.844 165.383C487.844 164.817 487.359 164.333 486.793 164.333C486.146 164.333 485.742 164.817 485.742 165.383Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.273 233.926C541.273 234.249 541.516 234.491 541.839 234.491C542.163 234.491 542.405 234.249 542.405 233.926C542.405 233.602 542.163 233.36 541.839 233.36C541.516 233.36 541.273 233.602 541.273 233.926Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.57 45.1918C636.57 45.5151 636.813 45.7576 637.136 45.7576C637.459 45.7576 637.702 45.5151 637.702 45.1918C637.702 44.8685 637.459 44.626 637.136 44.626C636.813 44.626 636.57 44.8685 636.57 45.1918Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.328 129.011C531.328 129.334 531.571 129.576 531.894 129.576C532.217 129.576 532.46 129.334 532.46 129.011C532.46 128.687 532.217 128.445 531.894 128.445C531.571 128.526 531.328 128.768 531.328 129.011Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.953 177.75C642.953 178.073 643.196 178.316 643.519 178.316C643.842 178.316 644.085 178.073 644.085 177.75C644.085 177.427 643.842 177.184 643.519 177.184C643.196 177.184 642.953 177.427 642.953 177.75Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.117 247.909C670.117 248.232 670.36 248.475 670.683 248.475C671.006 248.475 671.249 248.232 671.249 247.909C671.249 247.586 671.006 247.343 670.683 247.343C670.36 247.343 670.117 247.586 670.117 247.909Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.141 268.197C712.141 268.52 712.383 268.763 712.706 268.763C713.03 268.763 713.272 268.52 713.272 268.197C713.272 267.873 713.03 267.631 712.706 267.631C712.383 267.631 712.141 267.873 712.141 268.197Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.078 233.441C663.078 233.764 663.321 234.006 663.644 234.006C663.967 234.006 664.21 233.764 664.21 233.441C664.21 233.117 663.967 232.875 663.644 232.875C663.321 232.875 663.078 233.117 663.078 233.441Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.336 266.58C641.336 266.904 641.578 267.146 641.902 267.146C642.225 267.146 642.468 266.904 642.468 266.58C642.468 266.257 642.225 266.014 641.902 266.014C641.578 266.014 641.336 266.257 641.336 266.58Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.828 267.065C681.828 267.388 682.071 267.631 682.394 267.631C682.717 267.631 682.96 267.388 682.96 267.065C682.96 266.742 682.717 266.499 682.394 266.499C682.071 266.499 681.828 266.823 681.828 267.065Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.688 259.952C742.688 260.276 742.93 260.518 743.253 260.518C743.577 260.518 743.819 260.276 743.819 259.952C743.819 259.629 743.577 259.386 743.253 259.386C742.93 259.467 742.688 259.71 742.688 259.952Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.461 258.902C782.461 259.225 782.703 259.467 783.027 259.467C783.35 259.467 783.593 259.225 783.593 258.902C783.593 258.578 783.35 258.336 783.027 258.336C782.703 258.336 782.461 258.578 782.461 258.902Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.133 277.169C758.133 277.492 758.375 277.734 758.699 277.734C759.022 277.734 759.264 277.492 759.264 277.169C759.264 276.845 759.022 276.603 758.699 276.603C758.375 276.684 758.133 276.926 758.133 277.169Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.039 130.223C675.039 130.546 675.282 130.789 675.605 130.789C675.928 130.789 676.171 130.546 676.171 130.223C676.171 129.9 675.928 129.657 675.605 129.657C675.282 129.657 675.039 129.9 675.039 130.223Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.625 206.444C669.625 206.767 669.867 207.01 670.191 207.01C670.514 207.01 670.757 206.767 670.757 206.444C670.757 206.121 670.514 205.878 670.191 205.878C669.867 205.878 669.625 206.121 669.625 206.444Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.312 227.298C631.312 227.621 631.555 227.864 631.878 227.864C632.202 227.864 632.444 227.621 632.444 227.298C632.444 226.974 632.202 226.732 631.878 226.732C631.555 226.732 631.312 226.974 631.312 227.298Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.094 16.0128C762.094 16.3361 762.336 16.5786 762.66 16.5786C762.983 16.5786 763.225 16.3361 763.225 16.0128C763.225 15.6895 762.983 15.447 762.66 15.447C762.336 15.447 762.094 15.6895 762.094 16.0128Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.477 15.4471C814.477 15.7704 814.719 16.0129 815.042 16.0129C815.366 16.0129 815.608 15.7704 815.608 15.4471C815.608 15.1238 815.366 14.8813 815.042 14.8813C814.719 14.8813 814.477 15.1238 814.477 15.4471Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.234 67.7429C795.234 68.0662 795.477 68.3087 795.8 68.3087C796.123 68.3087 796.366 68.0662 796.366 67.7429C796.366 67.4196 796.123 67.1771 795.8 67.1771C795.477 67.258 795.234 67.5004 795.234 67.7429Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.602 99.5892C834.602 99.9125 834.844 100.155 835.167 100.155C835.491 100.155 835.733 99.9125 835.733 99.5892C835.733 99.2659 835.491 99.0234 835.167 99.0234C834.844 99.0234 834.602 99.2659 834.602 99.5892Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.734 76.7148C886.734 77.0382 886.977 77.2806 887.3 77.2806C887.623 77.2806 887.866 77.0382 887.866 76.7148C887.866 76.3915 887.623 76.149 887.3 76.149C886.977 76.149 886.734 76.4724 886.734 76.7148Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.234 95.1436C865.234 95.4669 865.477 95.7094 865.8 95.7094C866.123 95.7094 866.366 95.4669 866.366 95.1436C866.366 94.8203 866.123 94.5778 865.8 94.5778C865.477 94.5778 865.234 94.8203 865.234 95.1436Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.531 154.148C527.531 154.472 527.774 154.714 528.097 154.714C528.42 154.714 528.663 154.472 528.663 154.148C528.663 153.825 528.42 153.582 528.097 153.582C527.774 153.582 527.531 153.825 527.531 154.148Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.969 153.259C827.969 153.582 828.211 153.825 828.535 153.825C828.858 153.825 829.1 153.582 829.1 153.259C829.1 152.936 828.858 152.693 828.535 152.693C828.211 152.693 827.969 152.936 827.969 153.259Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.508 167.162C907.508 167.647 907.912 168.051 908.397 168.051C908.882 168.051 909.286 167.647 909.286 167.162C909.286 166.677 908.882 166.272 908.397 166.272C907.993 166.192 907.508 166.596 907.508 167.162Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.57 115.351C757.57 115.674 757.813 115.917 758.136 115.917C758.459 115.917 758.702 115.674 758.702 115.351C758.702 115.027 758.459 114.785 758.136 114.785C757.813 114.785 757.57 115.027 757.57 115.351Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.109 83.8277C748.109 84.3935 748.514 84.7977 749.079 84.7977C749.645 84.7977 750.049 84.3935 750.049 83.8277C750.049 83.2619 749.645 82.8578 749.079 82.8578C748.514 82.8578 748.109 83.3428 748.109 83.8277Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.305 98.781C739.305 99.1043 739.547 99.3468 739.87 99.3468C740.194 99.3468 740.436 99.1043 740.436 98.781C740.436 98.4576 740.194 98.2151 739.87 98.2151C739.547 98.2151 739.305 98.4576 739.305 98.781Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.453 206.202C960.453 207.414 961.423 208.465 962.716 208.465C963.929 208.465 964.98 207.495 964.98 206.202C964.98 204.989 964.01 203.938 962.716 203.938C961.423 203.938 960.453 204.989 960.453 206.202Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.719 141.62C865.719 142.509 866.446 143.156 867.254 143.156C868.144 143.156 868.79 142.428 868.79 141.62C868.79 140.731 868.063 140.084 867.254 140.084C866.446 140.084 865.719 140.812 865.719 141.62Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.195 116.886C713.195 117.776 713.923 118.422 714.731 118.422C715.62 118.422 716.267 117.695 716.267 116.886C716.267 115.997 715.539 115.351 714.731 115.351C713.923 115.351 713.195 115.997 713.195 116.886Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.812 62.489C808.812 62.8123 809.055 63.0548 809.378 63.0548C809.702 63.0548 809.944 62.8123 809.944 62.489C809.944 62.1657 809.702 61.9232 809.378 61.9232C809.055 61.9232 808.812 62.1657 808.812 62.489Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.695 70.3293C820.695 70.6527 820.938 70.8952 821.261 70.8952C821.584 70.8952 821.827 70.6527 821.827 70.3293C821.827 70.006 821.584 69.7635 821.261 69.7635C820.938 69.8444 820.695 70.0869 820.695 70.3293Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.227 27.5713C841.227 27.8946 841.469 28.1371 841.792 28.1371C842.116 28.1371 842.358 27.8946 842.358 27.5713C842.358 27.248 842.116 27.0055 841.792 27.0055C841.469 27.0055 841.227 27.248 841.227 27.5713Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.406 153.582C913.406 153.906 913.649 154.148 913.972 154.148C914.295 154.148 914.538 153.906 914.538 153.582C914.538 153.259 914.295 153.017 913.972 153.017C913.649 153.097 913.406 153.34 913.406 153.582Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.812 138.791C894.812 139.114 895.055 139.357 895.378 139.357C895.702 139.357 895.944 139.114 895.944 138.791C895.944 138.468 895.702 138.225 895.378 138.225C895.055 138.306 894.812 138.548 894.812 138.791Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.156 159.806C881.156 160.129 881.399 160.372 881.722 160.372C882.045 160.372 882.288 160.129 882.288 159.806C882.288 159.483 882.045 159.24 881.722 159.24C881.399 159.24 881.156 159.483 881.156 159.806Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.281 176.295C839.281 176.618 839.524 176.861 839.847 176.861C840.17 176.861 840.413 176.618 840.413 176.295C840.413 175.972 840.17 175.729 839.847 175.729C839.524 175.729 839.281 175.972 839.281 176.295Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.227 204.747C857.227 205.07 857.469 205.312 857.792 205.312C858.116 205.312 858.358 205.07 858.358 204.747C858.358 204.423 858.116 204.181 857.792 204.181C857.469 204.262 857.227 204.504 857.227 204.747Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.852 199.816C839.852 200.139 840.094 200.382 840.417 200.382C840.741 200.382 840.983 200.139 840.983 199.816C840.983 199.493 840.741 199.25 840.417 199.25C840.094 199.331 839.852 199.574 839.852 199.816Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.656 260.518C840.656 260.842 840.899 261.084 841.222 261.084C841.545 261.084 841.788 260.842 841.788 260.518C841.788 260.195 841.545 259.952 841.222 259.952C840.899 259.952 840.656 260.195 840.656 260.518Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.375 282.665C809.375 282.988 809.617 283.231 809.941 283.231C810.264 283.231 810.507 282.988 810.507 282.665C810.507 282.342 810.264 282.099 809.941 282.099C809.617 282.099 809.375 282.342 809.375 282.665Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.234 291.071C776.234 291.394 776.477 291.637 776.8 291.637C777.123 291.637 777.366 291.394 777.366 291.071C777.366 290.748 777.123 290.505 776.8 290.505C776.477 290.586 776.234 290.829 776.234 291.071Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.195 291.637C713.195 291.96 713.438 292.203 713.761 292.203C714.084 292.203 714.327 291.96 714.327 291.637C714.327 291.314 714.084 291.071 713.761 291.071C713.438 291.071 713.195 291.314 713.195 291.637Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.328 124.242C730.328 124.565 730.571 124.808 730.894 124.808C731.217 124.808 731.46 124.565 731.46 124.242C731.46 123.919 731.217 123.676 730.894 123.676C730.571 123.676 730.328 123.999 730.328 124.242Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.32 111.956C671.32 112.279 671.563 112.522 671.886 112.522C672.209 112.522 672.452 112.279 672.452 111.956C672.452 111.633 672.209 111.39 671.886 111.39C671.563 111.39 671.32 111.633 671.32 111.956Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.336 169.021C668.336 169.344 668.578 169.586 668.902 169.586C669.225 169.586 669.468 169.344 669.468 169.021C669.468 168.697 669.225 168.455 668.902 168.455C668.578 168.455 668.336 168.778 668.336 169.021Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.602 200.382C662.602 200.705 662.844 200.948 663.167 200.948C663.491 200.948 663.733 200.705 663.733 200.382C663.733 200.059 663.491 199.816 663.167 199.816C662.844 199.816 662.602 200.059 662.602 200.382Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.852 244.029C683.852 244.352 684.094 244.595 684.417 244.595C684.741 244.595 684.983 244.352 684.983 244.029C684.983 243.706 684.741 243.463 684.417 243.463C684.094 243.463 683.852 243.706 683.852 244.029Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.75 115.027C743.75 115.351 743.992 115.593 744.316 115.593C744.639 115.593 744.882 115.351 744.882 115.027C744.882 114.704 744.639 114.462 744.316 114.462C743.992 114.462 743.75 114.704 743.75 115.027Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.211 98.5385C769.211 98.8618 769.453 99.1042 769.777 99.1042C770.1 99.1042 770.343 98.8618 770.343 98.5385C770.343 98.2151 770.1 97.9727 769.777 97.9727C769.453 97.9727 769.211 98.2151 769.211 98.5385Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.797 83.8277C736.797 84.151 737.039 84.3935 737.363 84.3935C737.686 84.3935 737.928 84.151 737.928 83.8277C737.928 83.5044 737.686 83.2619 737.363 83.2619C737.039 83.2619 736.797 83.5852 736.797 83.8277Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.242 86.8184C679.242 87.1417 679.485 87.3842 679.808 87.3842C680.131 87.3842 680.374 87.1417 680.374 86.8184C680.374 86.495 680.131 86.2526 679.808 86.2526C679.485 86.2526 679.242 86.495 679.242 86.8184Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.844 47.2933C686.844 47.6166 687.086 47.8591 687.41 47.8591C687.733 47.8591 687.975 47.6166 687.975 47.2933C687.975 46.97 687.733 46.7275 687.41 46.7275C687.086 46.7275 686.844 46.97 686.844 47.2933Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.234 67.7429C701.234 68.0662 701.477 68.3087 701.8 68.3087C702.123 68.3087 702.366 68.0662 702.366 67.7429C702.366 67.4196 702.123 67.1771 701.8 67.1771C701.477 67.1771 701.234 67.5004 701.234 67.7429Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.742 52.8705C762.742 53.1939 762.985 53.4363 763.308 53.4363C763.631 53.4363 763.874 53.1939 763.874 52.8705C763.874 52.5472 763.631 52.3047 763.308 52.3047C762.985 52.3856 762.742 52.6281 762.742 52.8705Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.195 63.3782C780.195 63.7015 780.438 63.944 780.761 63.944C781.084 63.944 781.327 63.7015 781.327 63.3782C781.327 63.0549 781.084 62.8124 780.761 62.8124C780.438 62.8932 780.195 63.1357 780.195 63.3782Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.578 281.614C676.578 281.938 676.821 282.18 677.144 282.18C677.467 282.18 677.71 281.938 677.71 281.614C677.71 281.291 677.467 281.049 677.144 281.049C676.821 281.049 676.578 281.372 676.578 281.614Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.195 247.909C584.195 248.232 584.438 248.475 584.761 248.475C585.084 248.475 585.327 248.232 585.327 247.909C585.327 247.586 585.084 247.343 584.761 247.343C584.438 247.343 584.195 247.586 584.195 247.909Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.242 187.369C550.242 187.692 550.485 187.934 550.808 187.934C551.131 187.934 551.374 187.692 551.374 187.369C551.374 187.045 551.131 186.803 550.808 186.803C550.485 186.803 550.242 187.045 550.242 187.369Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.453 151.966C570.453 152.289 570.696 152.532 571.019 152.532C571.342 152.532 571.585 152.289 571.585 151.966C571.585 151.642 571.342 151.4 571.019 151.4C570.696 151.4 570.453 151.642 570.453 151.966Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.312 188.015C943.312 188.339 943.555 188.581 943.878 188.581C944.202 188.581 944.444 188.339 944.444 188.015C944.444 187.692 944.202 187.449 943.878 187.449C943.555 187.449 943.312 187.773 943.312 188.015Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.699 126.828C821.011 126.828 821.264 126.575 821.264 126.262C821.264 125.95 821.011 125.697 820.699 125.697C820.386 125.697 820.133 125.95 820.133 126.262C820.133 126.575 820.386 126.828 820.699 126.828Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.57 168.212C867.57 168.536 867.813 168.778 868.136 168.778C868.459 168.778 868.702 168.536 868.702 168.212C868.702 167.889 868.459 167.646 868.136 167.646C867.813 167.646 867.57 167.889 867.57 168.212Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.016 129.657C762.016 129.981 762.258 130.223 762.581 130.223C762.905 130.223 763.147 129.981 763.147 129.657C763.147 129.334 762.905 129.092 762.581 129.092C762.258 129.092 762.016 129.334 762.016 129.657Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.477 132.001C733.477 132.325 733.719 132.567 734.042 132.567C734.366 132.567 734.608 132.325 734.608 132.001C734.608 131.678 734.366 131.436 734.042 131.436C733.719 131.436 733.477 131.678 733.477 132.001Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.914 120.039C767.914 120.362 768.157 120.605 768.48 120.605C768.803 120.605 769.046 120.362 769.046 120.039C769.046 119.715 768.803 119.473 768.48 119.473C768.157 119.473 767.914 119.715 767.914 120.039Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.977 136.043C773.977 136.366 774.219 136.609 774.542 136.609C774.866 136.609 775.108 136.366 775.108 136.043C775.108 135.719 774.866 135.477 774.542 135.477C774.219 135.477 773.977 135.719 773.977 136.043Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.711 136.609C712.711 136.932 712.953 137.174 713.277 137.174C713.6 137.174 713.843 136.932 713.843 136.609C713.843 136.285 713.6 136.043 713.277 136.043C712.953 136.043 712.711 136.285 712.711 136.609Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.617 90.8597C723.617 91.1831 723.86 91.4255 724.183 91.4255C724.506 91.4255 724.749 91.1831 724.749 90.8597C724.749 90.5364 724.506 90.2939 724.183 90.2939C723.86 90.3748 723.617 90.6173 723.617 90.8597Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.812 102.742C679.812 103.065 680.055 103.307 680.378 103.307C680.702 103.307 680.944 103.065 680.944 102.742C680.944 102.418 680.702 102.176 680.378 102.176C680.055 102.257 679.812 102.499 679.812 102.742Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.945 97.7302C653.945 98.0535 654.188 98.296 654.511 98.296C654.834 98.296 655.077 98.0535 655.077 97.7302C655.077 97.4068 654.834 97.1644 654.511 97.1644C654.188 97.1644 653.945 97.4068 653.945 97.7302Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.328 75.6641C687.328 75.9874 687.571 76.2299 687.894 76.2299C688.217 76.2299 688.46 75.9874 688.46 75.6641C688.46 75.3407 688.217 75.0983 687.894 75.0983C687.571 75.0983 687.328 75.3407 687.328 75.6641Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.844 61.0341C686.844 61.3574 687.086 61.5999 687.41 61.5999C687.733 61.5999 687.975 61.3574 687.975 61.0341C687.975 60.7107 687.733 60.4683 687.41 60.4683C687.086 60.4683 686.844 60.7107 686.844 61.0341Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.781 59.3367C715.781 59.66 716.024 59.9025 716.347 59.9025C716.67 59.9025 716.913 59.66 716.913 59.3367C716.913 59.0134 716.67 58.7709 716.347 58.7709C716.024 58.8518 715.781 59.0942 715.781 59.3367Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.586 38.6448C735.586 38.9681 735.828 39.2106 736.152 39.2106C736.475 39.2106 736.718 38.9681 736.718 38.6448C736.718 38.3215 736.475 38.079 736.152 38.079C735.828 38.079 735.586 38.3215 735.586 38.6448Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.547 59.9026C774.547 60.2259 774.789 60.4684 775.113 60.4684C775.436 60.4684 775.678 60.2259 775.678 59.9026C775.678 59.5793 775.436 59.3368 775.113 59.3368C774.789 59.3368 774.547 59.5793 774.547 59.9026Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.023 38.0789C775.023 38.4022 775.266 38.6447 775.589 38.6447C775.913 38.6447 776.155 38.4022 776.155 38.0789C776.155 37.7556 775.913 37.5131 775.589 37.5131C775.266 37.594 775.023 37.8364 775.023 38.0789Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.438 84.7977C799.438 85.121 799.68 85.3635 800.003 85.3635C800.327 85.3635 800.569 85.121 800.569 84.7977C800.569 84.4744 800.327 84.2319 800.003 84.2319C799.68 84.3127 799.438 84.5552 799.438 84.7977Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.734 100.64C824.734 100.963 824.977 101.206 825.3 101.206C825.623 101.206 825.866 100.963 825.866 100.64C825.866 100.317 825.623 100.074 825.3 100.074C824.977 100.155 824.734 100.397 824.734 100.64Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.227 133.052C841.227 133.375 841.469 133.618 841.792 133.618C842.116 133.618 842.358 133.375 842.358 133.052C842.358 132.729 842.116 132.486 841.792 132.486C841.469 132.486 841.227 132.729 841.227 133.052Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.25 191.572C937.25 191.895 937.492 192.137 937.816 192.137C938.139 192.137 938.382 191.895 938.382 191.572C938.382 191.248 938.139 191.006 937.816 191.006C937.492 191.006 937.25 191.248 937.25 191.572Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.469 180.579C927.469 180.902 927.711 181.145 928.035 181.145C928.358 181.145 928.6 180.902 928.6 180.579C928.6 180.256 928.358 180.013 928.035 180.013C927.711 180.094 927.469 180.337 927.469 180.579Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.734 217.518C929.734 217.841 929.977 218.083 930.3 218.083C930.623 218.083 930.866 217.841 930.866 217.518C930.866 217.194 930.623 216.952 930.3 216.952C929.977 216.952 929.734 217.194 929.734 217.518Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.055 238.371C723.055 238.695 723.297 238.937 723.62 238.937C723.944 238.937 724.186 238.695 724.186 238.371C724.186 238.048 723.944 237.805 723.62 237.805C723.297 237.805 723.055 238.048 723.055 238.371Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.781 240.311C707.781 240.634 708.024 240.877 708.347 240.877C708.67 240.877 708.913 240.634 708.913 240.311C708.913 239.988 708.67 239.745 708.347 239.745C708.024 239.745 707.781 240.069 707.781 240.311Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.477 253.486C717.477 253.809 717.719 254.052 718.042 254.052C718.366 254.052 718.608 253.809 718.608 253.486C718.608 253.163 718.366 252.92 718.042 252.92C717.719 252.92 717.477 253.163 717.477 253.486Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M731.383 250.657C731.383 251.223 731.868 251.708 732.434 251.708C732.999 251.708 733.484 251.223 733.484 250.657C733.484 250.091 732.999 249.606 732.434 249.606C731.868 249.687 731.383 250.091 731.383 250.657Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.617 255.588C761.617 255.911 761.86 256.153 762.183 256.153C762.506 256.153 762.749 255.911 762.749 255.588C762.749 255.264 762.506 255.022 762.183 255.022C761.86 255.022 761.617 255.264 761.617 255.588Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.938 249.93C753.938 250.253 754.18 250.495 754.503 250.495C754.827 250.495 755.069 250.253 755.069 249.93C755.069 249.606 754.827 249.364 754.503 249.364C754.18 249.364 753.938 249.687 753.938 249.93Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.719 220.023C838.719 220.347 838.961 220.589 839.285 220.589C839.608 220.589 839.85 220.347 839.85 220.023C839.85 219.7 839.608 219.457 839.285 219.457C838.961 219.457 838.719 219.7 838.719 220.023Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.188 45.1918C794.188 46.3234 795.157 47.2933 796.289 47.2933C797.421 47.2933 798.391 46.3234 798.391 45.1918C798.391 44.0602 797.421 43.0903 796.289 43.0903C795.157 43.0903 794.188 43.9794 794.188 45.1918Z",
    fill: "#66ADE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.773 116.321C968.773 116.644 969.016 116.886 969.339 116.886C969.663 116.886 969.905 116.644 969.905 116.321C969.905 115.997 969.663 115.755 969.339 115.755C969.016 115.836 968.773 116.078 968.773 116.321Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.82 266.014C730.82 266.338 731.063 266.58 731.386 266.58C731.709 266.58 731.952 266.338 731.952 266.014C731.952 265.691 731.709 265.449 731.386 265.449C731.063 265.449 730.82 265.691 730.82 266.014Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.648 175.729C819.648 176.053 819.891 176.295 820.214 176.295C820.538 176.295 820.78 176.053 820.78 175.729C820.78 175.406 820.538 175.164 820.214 175.164C819.891 175.244 819.648 175.487 819.648 175.729Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.891 239.341C781.891 239.664 782.133 239.907 782.456 239.907C782.78 239.907 783.022 239.664 783.022 239.341C783.022 239.018 782.78 238.775 782.456 238.775C782.133 238.856 781.891 239.099 781.891 239.341Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.523 173.385C815.523 173.709 815.766 173.951 816.089 173.951C816.413 173.951 816.655 173.709 816.655 173.385C816.655 173.062 816.413 172.82 816.089 172.82C815.766 172.82 815.523 173.062 815.523 173.385Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.602 216.952C834.602 217.275 834.844 217.518 835.167 217.518C835.491 217.518 835.733 217.275 835.733 216.952C835.733 216.628 835.491 216.386 835.167 216.386C834.844 216.386 834.602 216.628 834.602 216.952Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.688 222.125C874.688 222.448 874.93 222.691 875.253 222.691C875.577 222.691 875.819 222.448 875.819 222.125C875.819 221.801 875.577 221.559 875.253 221.559C874.93 221.559 874.688 221.801 874.688 222.125Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.352 242.332C853.352 242.655 853.594 242.898 853.917 242.898C854.241 242.898 854.483 242.655 854.483 242.332C854.483 242.009 854.241 241.766 853.917 241.766C853.594 241.766 853.352 242.009 853.352 242.332Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.203 128.202C952.203 128.768 952.688 129.253 953.254 129.253C953.82 129.253 954.305 128.768 954.305 128.202C954.305 127.637 953.82 127.152 953.254 127.152C952.688 127.152 952.203 127.637 952.203 128.202Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.297 235.704C594.297 236.351 594.863 236.916 595.509 236.916C596.156 236.916 596.722 236.351 596.722 235.704C596.722 235.057 596.156 234.491 595.509 234.491C594.863 234.491 594.297 235.057 594.297 235.704Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.031 221.559C815.031 221.882 815.274 222.125 815.597 222.125C815.92 222.125 816.163 221.882 816.163 221.559C816.163 221.236 815.92 220.993 815.597 220.993C815.274 220.993 815.031 221.236 815.031 221.559Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.664 164.413C918.664 164.737 918.907 164.979 919.23 164.979C919.553 164.979 919.796 164.737 919.796 164.413C919.796 164.09 919.553 163.848 919.23 163.848C918.907 163.848 918.664 164.09 918.664 164.413Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.773 248.394C516.773 248.717 517.016 248.96 517.339 248.96C517.663 248.96 517.905 248.717 517.905 248.394C517.905 248.071 517.663 247.828 517.339 247.828C517.016 247.909 516.773 248.151 516.773 248.394Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.445 251.223C831.445 251.546 831.688 251.789 832.011 251.789C832.334 251.789 832.577 251.546 832.577 251.223C832.577 250.9 832.334 250.657 832.011 250.657C831.688 250.657 831.445 250.9 831.445 251.223Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.628 237.401C833.87 237.563 834.194 237.401 834.355 237.159C834.517 236.916 834.355 236.593 834.113 236.431C833.87 236.27 833.547 236.431 833.385 236.674C833.224 236.916 833.385 237.24 833.628 237.401Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.753 251.223C698.066 251.223 698.319 250.97 698.319 250.657C698.319 250.345 698.066 250.091 697.753 250.091C697.441 250.091 697.188 250.345 697.188 250.657C697.188 250.97 697.441 251.223 697.753 251.223Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.227 256.558C658.227 257.123 658.712 257.528 659.196 257.528C659.762 257.528 660.166 257.043 660.166 256.558C660.166 255.992 659.681 255.588 659.196 255.588C658.712 255.588 658.227 255.992 658.227 256.558Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.812 228.591C644.812 229.157 645.297 229.561 645.782 229.561C646.348 229.561 646.752 229.076 646.752 228.591C646.752 228.106 646.267 227.621 645.782 227.621C645.217 227.621 644.812 228.025 644.812 228.591Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.32 185.025C628.32 185.59 628.805 185.994 629.29 185.994C629.856 185.994 630.26 185.51 630.26 185.025C630.26 184.459 629.775 184.055 629.29 184.055C628.724 183.974 628.32 184.459 628.32 185.025Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.875 206.04C814.875 206.606 815.36 207.01 815.845 207.01C816.411 207.01 816.815 206.525 816.815 206.04C816.815 205.474 816.33 205.07 815.845 205.07C815.36 204.989 814.875 205.474 814.875 206.04Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.531 270.703C828.531 271.268 829.016 271.672 829.501 271.672C830.067 271.672 830.471 271.187 830.471 270.703C830.471 270.218 829.986 269.733 829.501 269.733C829.016 269.652 828.531 270.137 828.531 270.703Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.375 286.141C793.375 286.706 793.86 287.111 794.345 287.111C794.911 287.111 795.315 286.626 795.315 286.141C795.315 285.575 794.83 285.171 794.345 285.171C793.86 285.09 793.375 285.575 793.375 286.141Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.609 185.51C847.609 186.075 848.094 186.48 848.579 186.48C849.145 186.48 849.549 185.995 849.549 185.51C849.549 185.025 849.064 184.54 848.579 184.54C848.094 184.54 847.609 184.944 847.609 185.51Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.047 219.7C855.047 220.266 855.532 220.67 856.017 220.67C856.583 220.67 856.987 220.185 856.987 219.7C856.987 219.134 856.502 218.73 856.017 218.73C855.451 218.73 855.047 219.134 855.047 219.7Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.719 132.001C857.719 132.567 858.204 132.971 858.689 132.971C859.254 132.971 859.659 132.486 859.659 132.001C859.659 131.516 859.174 131.031 858.689 131.031C858.204 131.031 857.719 131.436 857.719 132.001Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.133 68.8745C844.133 69.4403 844.618 69.8445 845.103 69.8445C845.669 69.8445 846.073 69.3595 846.073 68.8745C846.073 68.3896 845.588 67.9046 845.103 67.9046C844.618 67.8238 844.133 68.3087 844.133 68.8745Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.898 92.5572C816.898 93.1229 817.383 93.5271 817.868 93.5271C818.434 93.5271 818.838 93.0421 818.838 92.5572C818.838 91.9914 818.353 91.5872 817.868 91.5872C817.383 91.5064 816.898 91.9914 816.898 92.5572Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.945 40.908C817.945 41.4738 818.43 41.8779 818.915 41.8779C819.481 41.8779 819.885 41.3929 819.885 40.908C819.885 40.3422 819.4 39.938 818.915 39.938C818.349 39.8572 817.945 40.3422 817.945 40.908Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.125 18.5185C785.125 19.0843 785.61 19.4885 786.095 19.4885C786.661 19.4885 787.065 19.0035 787.065 18.5185C787.065 17.9527 786.58 17.5486 786.095 17.5486C785.61 17.5486 785.125 18.0336 785.125 18.5185Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.914 0.978781C751.914 1.54458 752.399 1.94872 752.884 1.94872C753.45 1.94872 753.854 1.46375 753.854 0.978781C753.854 0.412984 753.369 0.00884559 752.884 0.00884559C752.399 -0.0719826 751.914 0.412984 751.914 0.978781Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.367 8.9808C683.367 9.5466 683.852 9.95074 684.337 9.95074C684.903 9.95074 685.307 9.46577 685.307 8.9808C685.307 8.49583 684.822 8.01086 684.337 8.01086C683.852 8.01086 683.367 8.415 683.367 8.9808Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.125 54.4062C648.125 54.972 648.61 55.3762 649.095 55.3762C649.661 55.3762 650.065 54.8912 650.065 54.4062C650.065 53.8404 649.58 53.4363 649.095 53.4363C648.61 53.4363 648.125 53.9212 648.125 54.4062Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.086 99.8317C636.086 100.397 636.571 100.802 637.056 100.802C637.622 100.802 638.026 100.317 638.026 99.8317C638.026 99.3467 637.541 98.8618 637.056 98.8618C636.571 98.7809 636.086 99.2659 636.086 99.8317Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M598.984 248.394C598.984 249.606 599.954 250.495 601.086 250.495C602.298 250.495 603.187 249.525 603.187 248.394C603.187 247.181 602.218 246.292 601.086 246.292C599.954 246.292 598.984 247.262 598.984 248.394Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.695 103.307C707.695 103.631 707.938 103.873 708.261 103.873C708.584 103.873 708.827 103.631 708.827 103.307C708.827 102.984 708.584 102.742 708.261 102.742C707.938 102.742 707.695 102.984 707.695 103.307Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.359 98.2151C753.359 98.5384 753.602 98.7809 753.925 98.7809C754.248 98.7809 754.491 98.5384 754.491 98.2151C754.491 97.8918 754.248 97.6493 753.925 97.6493C753.602 97.6493 753.359 97.9726 753.359 98.2151Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.906 129.657C711.906 129.981 712.149 130.223 712.472 130.223C712.795 130.223 713.038 129.981 713.038 129.657C713.038 129.334 712.795 129.092 712.472 129.092C712.149 129.092 711.906 129.334 711.906 129.657Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.891 111.228C730.891 111.552 731.133 111.794 731.456 111.794C731.78 111.794 732.022 111.552 732.022 111.228C732.022 110.905 731.78 110.663 731.456 110.663C731.133 110.663 730.891 110.905 730.891 111.228Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.18 52.3856C700.18 52.7089 700.422 52.9514 700.745 52.9514C701.069 52.9514 701.311 52.7089 701.311 52.3856C701.311 52.0622 701.069 51.8198 700.745 51.8198C700.422 51.8198 700.18 52.0622 700.18 52.3856Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.156 100.155C612.156 100.478 612.399 100.721 612.722 100.721C613.045 100.721 613.288 100.478 613.288 100.155C613.288 99.8317 613.045 99.5892 612.722 99.5892C612.399 99.5892 612.156 99.8317 612.156 100.155Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.414 244.595C574.414 244.918 574.657 245.161 574.98 245.161C575.303 245.161 575.546 244.918 575.546 244.595C575.546 244.272 575.303 244.029 574.98 244.029C574.657 244.029 574.414 244.272 574.414 244.595Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.906 161.746C614.906 162.069 615.149 162.312 615.472 162.312C615.795 162.312 616.038 162.069 616.038 161.746C616.038 161.423 615.795 161.18 615.472 161.18C615.149 161.18 614.906 161.423 614.906 161.746Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.836 236.593C584.836 237.078 585.24 237.482 585.725 237.482C586.21 237.482 586.614 237.078 586.614 236.593C586.614 236.108 586.21 235.704 585.725 235.704C585.24 235.704 584.836 236.108 584.836 236.593Z",
    fill: "#8CE8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.43 57.9627C740.43 58.771 741.076 59.3368 741.804 59.3368C742.531 59.3368 743.178 58.6902 743.178 57.9627C743.178 57.1544 742.531 56.5886 741.804 56.5886C741.076 56.5886 740.43 57.2353 740.43 57.9627Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.406 215.82C593.406 216.143 593.649 216.386 593.972 216.386C594.295 216.386 594.538 216.143 594.538 215.82C594.538 215.497 594.295 215.254 593.972 215.254C593.649 215.254 593.406 215.578 593.406 215.82Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.68 193.027C909.68 193.35 909.922 193.592 910.245 193.592C910.569 193.592 910.811 193.35 910.811 193.027C910.811 192.703 910.569 192.461 910.245 192.461C909.922 192.461 909.68 192.703 909.68 193.027Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.816 23.1257C693.128 23.1257 693.382 22.8724 693.382 22.5599C693.382 22.2475 693.128 21.9941 692.816 21.9941C692.503 21.9941 692.25 22.2475 692.25 22.5599C692.25 22.8724 692.503 23.1257 692.816 23.1257Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.219 53.7595C825.219 54.0828 825.461 54.3253 825.785 54.3253C826.108 54.3253 826.35 54.0828 826.35 53.7595C826.35 53.4362 826.108 53.1937 825.785 53.1937C825.461 53.1937 825.219 53.517 825.219 53.7595Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.086 211.132C636.086 211.455 636.328 211.698 636.652 211.698C636.975 211.698 637.218 211.455 637.218 211.132C637.218 210.809 636.975 210.566 636.652 210.566C636.328 210.566 636.086 210.809 636.086 211.132Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.906 164.979C641.906 165.303 642.149 165.545 642.472 165.545C642.795 165.545 643.038 165.303 643.038 164.979C643.038 164.656 642.795 164.413 642.472 164.413C642.149 164.413 641.906 164.656 641.906 164.979Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.734 199.331C644.734 199.655 644.977 199.897 645.3 199.897C645.623 199.897 645.866 199.655 645.866 199.331C645.866 199.008 645.623 198.765 645.3 198.765C644.977 198.765 644.734 199.008 644.734 199.331Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.183 98.5385C501.495 98.5385 501.749 98.2851 501.749 97.9727C501.749 97.6602 501.495 97.4069 501.183 97.4069C500.871 97.4069 500.617 97.6602 500.617 97.9727C500.617 98.2851 500.871 98.5385 501.183 98.5385Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.422 258.902C794.422 259.225 794.664 259.467 794.988 259.467C795.311 259.467 795.553 259.225 795.553 258.902C795.553 258.578 795.311 258.336 794.988 258.336C794.664 258.336 794.422 258.578 794.422 258.902Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.586 161.746C837.586 162.069 837.828 162.312 838.152 162.312C838.475 162.312 838.718 162.069 838.718 161.746C838.718 161.423 838.475 161.18 838.152 161.18C837.828 161.18 837.586 161.423 837.586 161.746Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.352 248.556C565.352 248.879 565.594 249.121 565.917 249.121C566.241 249.121 566.483 248.879 566.483 248.556C566.483 248.232 566.241 247.99 565.917 247.99C565.594 247.99 565.352 248.232 565.352 248.556Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.792 126.667C659.105 126.667 659.358 126.413 659.358 126.101C659.358 125.788 659.105 125.535 658.792 125.535C658.48 125.535 658.227 125.788 658.227 126.101C658.227 126.413 658.48 126.667 658.792 126.667Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.735 242.655C548.137 242.655 548.463 242.329 548.463 241.928C548.463 241.526 548.137 241.2 547.735 241.2C547.333 241.2 547.008 241.526 547.008 241.928C547.008 242.329 547.333 242.655 547.735 242.655Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.477 222.61C491.477 222.933 491.719 223.176 492.042 223.176C492.366 223.176 492.608 222.933 492.608 222.61C492.608 222.286 492.366 222.044 492.042 222.044C491.719 222.125 491.477 222.367 491.477 222.61Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.602 107.834C624.602 108.157 624.844 108.399 625.167 108.399C625.491 108.399 625.733 108.157 625.733 107.834C625.733 107.51 625.491 107.268 625.167 107.268C624.844 107.268 624.602 107.51 624.602 107.834Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.953 120.605C626.953 120.928 627.196 121.17 627.519 121.17C627.842 121.17 628.085 120.928 628.085 120.605C628.085 120.281 627.842 120.039 627.519 120.039C627.196 120.039 626.953 120.281 626.953 120.605Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.094 42.9286C848.094 43.252 848.336 43.4944 848.66 43.4944C848.983 43.4944 849.225 43.252 849.225 42.9286C849.225 42.6053 848.983 42.3629 848.66 42.3629C848.336 42.3629 848.094 42.6053 848.094 42.9286Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.969 233.926C854.969 234.249 855.211 234.491 855.535 234.491C855.858 234.491 856.1 234.249 856.1 233.926C856.1 233.602 855.858 233.36 855.535 233.36C855.211 233.441 854.969 233.683 854.969 233.926Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.969 134.992C588.969 135.315 589.211 135.558 589.535 135.558C589.858 135.558 590.1 135.315 590.1 134.992C590.1 134.669 589.858 134.426 589.535 134.426C589.211 134.426 588.969 134.669 588.969 134.992Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.125 121.09C648.125 121.413 648.367 121.655 648.691 121.655C649.014 121.655 649.257 121.413 649.257 121.09C649.257 120.766 649.014 120.524 648.691 120.524C648.367 120.605 648.125 120.847 648.125 121.09Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.383 226.409C653.383 226.732 653.625 226.974 653.949 226.974C654.272 226.974 654.514 226.732 654.514 226.409C654.514 226.085 654.272 225.843 653.949 225.843C653.625 225.843 653.383 226.085 653.383 226.409Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.156 54.972C846.156 55.2953 846.399 55.5378 846.722 55.5378C847.045 55.5378 847.288 55.2953 847.288 54.972C847.288 54.6487 847.045 54.4062 846.722 54.4062C846.399 54.4062 846.156 54.6487 846.156 54.972Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M530.117 50.6073C530.117 51.2539 530.683 51.8197 531.33 51.8197C531.976 51.8197 532.542 51.2539 532.542 50.6073C532.542 49.9607 531.976 49.3949 531.33 49.3949C530.683 49.3949 530.117 49.8799 530.117 50.6073Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 193.592C464 194.158 464.485 194.643 465.051 194.643C465.617 194.643 466.102 194.158 466.102 193.592C466.102 193.027 465.617 192.542 465.051 192.542C464.485 192.542 464 192.946 464 193.592Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.664 64.9139C918.664 65.4797 919.149 65.9646 919.715 65.9646C920.281 65.9646 920.766 65.4797 920.766 64.9139C920.766 64.3481 920.281 63.8631 919.715 63.8631C919.149 63.8631 918.664 64.3481 918.664 64.9139Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.225 77.7656C945.74 79.6246 947.922 81.2412 949.781 79.7863C951.236 77.8464 949.62 75.7449 947.761 76.2298C947.033 76.4723 946.467 77.0381 946.225 77.7656Z",
    fill: "#9AF6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.375 146.47C594.133 147.601 595.345 148.49 596.477 147.682C597.366 146.55 596.396 145.338 595.264 145.58C594.779 145.661 594.456 146.065 594.375 146.47Z",
    fill: "#9AF6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.676 87.6266C612.256 87.6266 612.727 87.1561 612.727 86.5758C612.727 85.9955 612.256 85.525 611.676 85.525C611.095 85.525 610.625 85.9955 610.625 86.5758C610.625 87.1561 611.095 87.6266 611.676 87.6266Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.426 57.9627C620.006 57.9627 620.477 57.4923 620.477 56.912C620.477 56.3317 620.006 55.8612 619.426 55.8612C618.845 55.8612 618.375 56.3317 618.375 56.912C618.375 57.4923 618.845 57.9627 619.426 57.9627Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.09 69.8444C609.67 69.8444 610.141 69.374 610.141 68.7936C610.141 68.2133 609.67 67.7429 609.09 67.7429C608.509 67.7429 608.039 68.2133 608.039 68.7936C608.039 69.374 608.509 69.8444 609.09 69.8444Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.965 64.5906C570.545 64.5906 571.016 64.1202 571.016 63.5398C571.016 62.9595 570.545 62.4891 569.965 62.4891C569.384 62.4891 568.914 62.9595 568.914 63.5398C568.914 64.1202 569.384 64.5906 569.965 64.5906Z",
    fill: "#83E8D2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.266,
    y: 33.0272,
    width: 15.3574,
    height: 15.3574,
    fill: "url(#pattern0_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.555 40.4229C615.232 42.0395 616.606 43.3327 618.223 43.0902C619.112 42.9286 619.839 42.2011 620.001 41.312C620.324 39.6955 618.95 38.4022 617.334 38.6447C616.444 38.8872 615.717 39.5338 615.555 40.4229Z",
    fill: "#7DDCE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.094,
    y: 217.315,
    width: 15.3574,
    height: 15.3574,
    fill: "url(#pattern1_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.79 224.63C911.466 226.247 912.84 227.54 914.457 227.298C915.346 227.136 916.074 226.409 916.235 225.519C916.559 223.903 915.184 222.61 913.568 222.852C912.679 223.014 911.951 223.741 911.79 224.63Z",
    fill: "#7DDCE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 794.555,
    y: 99.3063,
    width: 15.3574,
    height: 14.5491,
    fill: "url(#pattern2_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.922 106.621C799.922 107.834 800.892 108.884 802.185 108.884C803.397 108.884 804.448 107.915 804.448 106.621C804.448 105.409 803.478 104.358 802.185 104.358C800.973 104.358 799.922 105.328 799.922 106.621Z",
    fill: "#B3F3F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 741.203,
    y: 129.213,
    width: 15.3574,
    height: 14.5491,
    fill: "url(#pattern3_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.82 136.609C746.82 137.821 747.79 138.872 749.084 138.872C750.296 138.872 751.347 137.902 751.347 136.609C751.347 135.396 750.377 134.345 749.084 134.345C747.79 134.345 746.82 135.315 746.82 136.609Z",
    fill: "#B3F3F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 575.203,
    y: 166.898,
    width: 13.7408,
    height: 12.9325,
    fill: "url(#pattern4_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.227 173.385C580.227 174.436 581.035 175.244 582.086 175.244C583.136 175.244 583.945 174.436 583.945 173.385C583.945 172.335 583.136 171.526 582.086 171.526C581.035 171.526 580.227 172.335 580.227 173.385Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.617,
    y: 176.223,
    width: 12.1242,
    height: 12.9325,
    fill: "url(#pattern5_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.883 182.6C655.883 183.489 656.61 184.297 657.58 184.297C658.55 184.297 659.278 183.57 659.278 182.6C659.278 181.711 658.55 180.902 657.58 180.902C656.61 180.902 655.883 181.63 655.883 182.6Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.24 237.582H783.442L779.065 241.864H756.039",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.664 235.489L751.849 241.674",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.531 192.102H699.328L706.083 198.762H709.223",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 199.714H653.373L661.461 207.896H672.117",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.109 201.617H692.661L699.417 208.467H707.028",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.516 214.462H671.17L676.784 220.075H694.386",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.008 209.133H687.144L692.948 214.937",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 221.788H662.983L669.167 227.973H687.15",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 208.467L650.614 213.986",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 229.305H657.75L663.459 234.918H678.111L684.296 241.103H704.848L710.557 235.394",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.297 235.204H702.185",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 235.204H655.942L662.127 241.388",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.711 147.097H722.356",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.367 158.515H733.02L741.012 166.507",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.898 159.562H763.545",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.531 148.62L740.527 152.616H757.559L767.549 142.625",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.297 175.356H744.716L748.713 179.352H771.072",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.57 173.263H770.41L774.881 168.696H795.243",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.243 158.42H771.741L763.558 166.602H746.812",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.406 148.62H795.244",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.367 151.284L768.317 154.233H777.07",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.236 179.352H780.203L772.877 186.679H756.797",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.961 184.014L738.718 188.772H749.47",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.383 183.444H746.426",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.383 147.097H755.369",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.531 196.098H751.559",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.18 192.863H765.36L771.545 199.048H795.237",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.93 189.818L776.404 192.292H795.243",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.445 186.393H795.244",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.445 174.024H795.242",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.531 205.803H744.425L749.658 200.57H762.788",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.648 205.042L760.691 209.99H775.249L778.864 206.374H795.23",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.563 212.083H733.867",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.188 217.221H765.176L770.599 222.644H795.243",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.5 213.7L775.164 216.46H795.24",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.961 221.788H753.563L759.558 227.877H772.498",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.688 231.779H731.863L745.659 245.48",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.219 240.532H727.586L732.534 245.48",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.711 231.779H751.56L755.27 235.489H775.251L779.914 230.827H795.232",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 148.62H661.746",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 160.513H663.554L671.546 168.505",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.109 158.8L680.102 166.793H692.661",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 166.793H659.367L668.501 175.927H685.913L690.195 171.645H705.99",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 175.356H655.942L664.125 183.634",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.305 154.233L684.584 160.608H703.804L713.034 151.284H728.923",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.102 154.233H700.946",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.846 178.591H692.667L685.151 186.108H671.164",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 182.492H653.373",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 188.867H653.373L659.843 195.337H680.966",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.084 183.729H695.047",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 154.233H666.884L673.925 147.097H691.432",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.656 138.724H660.031L664.979 133.777",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.926 130.542H662.887L658.891 126.545",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.656 131.969H659.746",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.266 121.027H671.54",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.656 115.223H661.744L666.882 110.085",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.266 104.852H672.111",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.469 96.8594H663.842L669.551 91.1505H671.929",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.227 83.3484L663.937 87.0592H670.027",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.219 82.8727H680.778",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.367 74.4997L668.602 77.7347H680.02",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.922 66.5073L676.965 71.5501H687.812L699.895 59.4664H732.721",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.109 60.7033L681.725 64.3189H686.863L696.187 54.9944H703.99",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.039 47.4778L708.94 51.3788H730.443",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.977 55.7556H739.676L745.67 61.7499H763.368",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.812 62.3208L746.426 68.0296H769.262",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.625 54.9944H753.949",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.531 56.7072H688.289",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.039 75.0705H763.362L768.024 70.4083",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.367 79.4474L767.173 83.2533H779.923",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.781 78.2104H777.247",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.125 96.7642L771.453 91.436H779.921",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.125 87.6301H768.024",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.406 98.4768H785.158",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.828 104.186H772.585L775.63 107.23H781.815",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.016 112.083H786.573",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.312 121.883H772.594L776.21 118.268H782.68",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.312 128.163H777.256L781.538 123.881",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.016 133.111H778.961L781.055 135.109H786.573",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.312 139.581H774.402L777.256 136.631",
    stroke: "#00A0FC",
    strokeWidth: 1.71921,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.783 133.111C772.783 133.586 772.402 133.967 771.927 133.967C771.451 133.967 771.07 133.586 771.07 133.111C771.07 132.635 771.451 132.254 771.927 132.254C772.402 132.254 772.783 132.635 772.783 133.111Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.255 137.487C777.728 137.487 778.111 137.104 778.111 136.631C778.111 136.158 777.728 135.775 777.255 135.775C776.782 135.775 776.398 136.158 776.398 136.631C776.398 137.104 776.782 137.487 777.255 137.487Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.919 152.14C729.392 152.14 729.775 151.757 729.775 151.284C729.775 150.811 729.392 150.427 728.919 150.427C728.446 150.427 728.062 150.811 728.062 151.284C728.062 151.757 728.446 152.14 728.919 152.14Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.205 158.42C719.205 158.896 718.824 159.276 718.349 159.276C717.873 159.276 717.492 158.896 717.492 158.42C717.492 157.944 717.873 157.563 718.349 157.563C718.824 157.563 719.205 157.944 719.205 158.42Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.283 148.62C737.283 149.095 736.902 149.476 736.427 149.476C735.951 149.476 735.57 149.095 735.57 148.62C735.57 148.144 735.951 147.763 736.427 147.763C736.902 147.763 737.283 148.144 737.283 148.62Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.142 147.097C742.142 147.573 741.762 147.954 741.286 147.954C740.81 147.954 740.43 147.573 740.43 147.097C740.43 146.622 740.81 146.241 741.286 146.241C741.762 146.336 742.142 146.717 742.142 147.097Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.127 147.097C756.127 147.573 755.746 147.954 755.27 147.954C754.795 147.954 754.414 147.573 754.414 147.097C754.414 146.622 754.795 146.241 755.27 146.241C755.746 146.336 756.127 146.717 756.127 147.097Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.408 159.562C764.408 160.037 764.027 160.418 763.552 160.418C763.076 160.418 762.695 160.037 762.695 159.562C762.695 159.086 763.076 158.705 763.552 158.705C764.027 158.705 764.408 159.086 764.408 159.562Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.127 151.284C766.127 151.76 765.746 152.14 765.27 152.14C764.795 152.14 764.414 151.76 764.414 151.284C764.414 150.808 764.795 150.427 765.27 150.427C765.746 150.523 766.127 150.808 766.127 151.284Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.158 148.62C775.158 149.095 774.777 149.476 774.302 149.476C773.826 149.476 773.445 149.095 773.445 148.62C773.445 148.144 773.826 147.763 774.302 147.763C774.777 147.763 775.158 148.144 775.158 148.62Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.83 154.233C777.83 154.709 777.449 155.09 776.973 155.09C776.498 155.09 776.117 154.709 776.117 154.233C776.117 153.758 776.498 153.377 776.973 153.377C777.544 153.472 777.83 153.853 777.83 154.233Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.142 183.444C742.142 183.919 741.762 184.3 741.286 184.3C740.81 184.3 740.43 183.919 740.43 183.444C740.43 182.968 740.81 182.587 741.286 182.587C741.762 182.587 742.142 182.968 742.142 183.444Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.611 241.674C752.611 242.15 752.23 242.53 751.755 242.53C751.279 242.53 750.898 242.15 750.898 241.674C750.898 241.198 751.279 240.818 751.755 240.818C752.23 240.818 752.611 241.198 752.611 241.674Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.892 241.864C756.892 242.34 756.512 242.72 756.036 242.72C755.56 242.72 755.18 242.34 755.18 241.864C755.18 241.388 755.56 241.008 756.036 241.008C756.512 241.103 756.892 241.484 756.892 241.864Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.572 231.779C743.572 232.254 743.191 232.635 742.716 232.635C742.24 232.635 741.859 232.254 741.859 231.779C741.859 231.303 742.24 230.922 742.716 230.922C743.191 230.922 743.572 231.303 743.572 231.779Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.041 235.204C703.041 235.68 702.66 236.06 702.184 236.06C701.709 236.06 701.328 235.68 701.328 235.204C701.328 234.728 701.709 234.348 702.184 234.348C702.66 234.348 703.041 234.728 703.041 235.204Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.294 236.06C684.767 236.06 685.15 235.677 685.15 235.204C685.15 234.731 684.767 234.348 684.294 234.348C683.821 234.348 683.438 234.731 683.438 235.204C683.438 235.677 683.821 236.06 684.294 236.06Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.885 241.388C662.885 241.864 662.504 242.245 662.028 242.245C661.552 242.245 661.172 241.864 661.172 241.388C661.172 240.913 661.552 240.532 662.028 240.532C662.504 240.532 662.885 240.913 662.885 241.388Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.752 54.9945C704.752 55.4703 704.371 55.8508 703.895 55.8508C703.42 55.8508 703.039 55.4703 703.039 54.9945C703.039 54.5188 703.42 54.1382 703.895 54.1382C704.371 54.1382 704.752 54.5188 704.752 54.9945Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.197 51.3789C731.197 51.8547 730.816 52.2352 730.341 52.2352C729.865 52.2352 729.484 51.8547 729.484 51.3789C729.484 50.9032 729.865 50.5226 730.341 50.5226C730.816 50.5226 731.197 50.9032 731.197 51.3789Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.47 54.9945C745.47 55.4703 745.09 55.8508 744.614 55.8508C744.138 55.8508 743.758 55.4703 743.758 54.9945C743.758 54.5188 744.138 54.1382 744.614 54.1382C745.09 54.1382 745.47 54.5188 745.47 54.9945Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.974 56.6121C724.446 56.6121 724.83 56.2287 724.83 55.7557C724.83 55.2828 724.446 54.8994 723.974 54.8994C723.501 54.8994 723.117 55.2828 723.117 55.7557C723.117 56.2287 723.501 56.6121 723.974 56.6121Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.724 60.3228C733.196 60.3228 733.58 59.9394 733.58 59.4664C733.58 58.9935 733.196 58.6101 732.724 58.6101C732.251 58.6101 731.867 58.9935 731.867 59.4664C731.867 59.9394 732.251 60.3228 732.724 60.3228Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.674 62.3208C741.674 62.7966 741.293 63.1771 740.817 63.1771C740.342 63.1771 739.961 62.7966 739.961 62.3208C739.961 61.8451 740.342 61.4645 740.817 61.4645C741.293 61.5596 741.674 61.9402 741.674 62.3208Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.221 79.4474C764.221 79.9231 763.84 80.3037 763.364 80.3037C762.888 80.3037 762.508 79.9231 762.508 79.4474C762.508 78.9717 762.888 78.5911 763.364 78.5911C763.84 78.5911 764.221 78.9717 764.221 79.4474Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.556 78.2106C767.556 78.6863 767.176 79.0669 766.7 79.0669C766.224 79.0669 765.844 78.6863 765.844 78.2106C765.844 77.7348 766.224 77.3542 766.7 77.3542C767.176 77.3542 767.556 77.7348 767.556 78.2106Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.02 71.2648C768.493 71.2648 768.877 70.8814 768.877 70.4085C768.877 69.9355 768.493 69.5521 768.02 69.5521C767.547 69.5521 767.164 69.9355 767.164 70.4085C767.164 70.8814 767.547 71.2648 768.02 71.2648Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.02 88.4865C768.493 88.4865 768.877 88.1031 768.877 87.6301C768.877 87.1572 768.493 86.7738 768.02 86.7738C767.547 86.7738 767.164 87.1572 767.164 87.6301C767.164 88.1031 767.547 88.4865 768.02 88.4865Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.775 91.436C780.775 91.9118 780.395 92.2924 779.919 92.2924C779.443 92.2924 779.062 91.9118 779.062 91.436C779.062 90.9603 779.443 90.5797 779.919 90.5797C780.395 90.5797 780.775 90.9603 780.775 91.436Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.158 98.4769C775.158 98.9527 774.777 99.3333 774.302 99.3333C773.826 99.3333 773.445 98.9527 773.445 98.4769C773.445 98.0012 773.826 97.6206 774.302 97.6206C774.777 97.6206 775.158 98.0012 775.158 98.4769Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.674 107.23C782.674 107.706 782.293 108.087 781.817 108.087C781.342 108.087 780.961 107.706 780.961 107.23C780.961 106.755 781.342 106.374 781.817 106.374C782.293 106.374 782.674 106.85 782.674 107.23Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.783 112.083C772.783 112.559 772.402 112.939 771.927 112.939C771.451 112.939 771.07 112.559 771.07 112.083C771.07 111.607 771.451 111.227 771.927 111.227C772.402 111.227 772.783 111.702 772.783 112.083Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.635 118.268C783.635 118.743 783.254 119.124 782.778 119.124C782.302 119.124 781.922 118.743 781.922 118.268C781.922 117.792 782.302 117.411 782.778 117.411C783.254 117.506 783.635 117.792 783.635 118.268Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.299 123.881C782.299 124.357 781.918 124.738 781.442 124.738C780.967 124.738 780.586 124.357 780.586 123.881C780.586 123.406 780.967 123.025 781.442 123.025C781.918 123.025 782.299 123.501 782.299 123.881Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.114 184.49C664.587 184.49 664.97 184.107 664.97 183.634C664.97 183.161 664.587 182.778 664.114 182.778C663.641 182.778 663.258 183.161 663.258 183.634C663.258 184.107 663.641 184.49 664.114 184.49Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.931 186.108C671.931 186.584 671.551 186.964 671.075 186.964C670.599 186.964 670.219 186.584 670.219 186.108C670.219 185.632 670.599 185.251 671.075 185.251C671.551 185.347 671.931 185.632 671.931 186.108Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.044 184.585C695.517 184.585 695.9 184.202 695.9 183.729C695.9 183.256 695.517 182.873 695.044 182.873C694.571 182.873 694.188 183.256 694.188 183.729C694.188 184.202 694.571 184.585 695.044 184.585Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.385 192.102C686.385 192.578 686.004 192.958 685.528 192.958C685.052 192.958 684.672 192.578 684.672 192.102C684.672 191.626 685.052 191.246 685.528 191.246C686.004 191.246 686.385 191.626 686.385 192.102Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.822 195.337C681.822 195.813 681.441 196.193 680.966 196.193C680.49 196.193 680.109 195.813 680.109 195.337C680.109 194.861 680.49 194.481 680.966 194.481C681.441 194.481 681.822 194.861 681.822 195.337Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.372 183.349C653.845 183.349 654.228 182.965 654.228 182.492C654.228 182.019 653.845 181.636 653.372 181.636C652.899 181.636 652.516 182.019 652.516 182.492C652.516 182.965 652.899 183.349 653.372 183.349Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.927 202.473C672.4 202.473 672.783 202.09 672.783 201.617C672.783 201.144 672.4 200.76 671.927 200.76C671.454 200.76 671.07 201.144 671.07 201.617C671.07 202.09 671.454 202.473 671.927 202.473Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.885 207.896C672.885 208.372 672.504 208.753 672.028 208.753C671.552 208.753 671.172 208.372 671.172 207.896C671.172 207.421 671.552 207.04 672.028 207.04C672.504 207.04 672.885 207.421 672.885 207.896Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.869 209.133C680.869 209.609 680.488 209.99 680.013 209.99C679.537 209.99 679.156 209.609 679.156 209.133C679.156 208.658 679.537 208.277 680.013 208.277C680.488 208.372 680.869 208.753 680.869 209.133Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.814 214.937C693.814 215.413 693.434 215.794 692.958 215.794C692.482 215.794 692.102 215.413 692.102 214.937C692.102 214.462 692.482 214.081 692.958 214.081C693.434 214.176 693.814 214.557 693.814 214.937Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.236 220.075C695.236 220.551 694.855 220.932 694.38 220.932C693.904 220.932 693.523 220.551 693.523 220.075C693.523 219.6 693.904 219.219 694.38 219.219C694.855 219.219 695.236 219.6 695.236 220.075Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.002 227.973C688.002 228.448 687.621 228.829 687.145 228.829C686.67 228.829 686.289 228.448 686.289 227.973C686.289 227.497 686.67 227.116 687.145 227.116C687.621 227.211 688.002 227.592 688.002 227.973Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.416 235.394C711.416 235.87 711.035 236.251 710.559 236.251C710.084 236.251 709.703 235.87 709.703 235.394C709.703 234.918 710.084 234.538 710.559 234.538C711.035 234.538 711.416 234.918 711.416 235.394Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.7 232.635C716.173 232.635 716.556 232.252 716.556 231.779C716.556 231.306 716.173 230.922 715.7 230.922C715.227 230.922 714.844 231.306 714.844 231.779C714.844 232.252 715.227 232.635 715.7 232.635Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.224 241.388C713.696 241.388 714.08 241.005 714.08 240.532C714.08 240.059 713.696 239.676 713.224 239.676C712.751 239.676 712.367 240.059 712.367 240.532C712.367 241.005 712.751 241.388 713.224 241.388Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.424 235.489C746.424 235.965 746.043 236.346 745.567 236.346C745.092 236.346 744.711 235.965 744.711 235.489C744.711 235.014 745.092 234.633 745.567 234.633C746.138 234.728 746.424 235.014 746.424 235.489Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.267 227.878C773.267 228.353 772.887 228.734 772.411 228.734C771.935 228.734 771.555 228.353 771.555 227.878C771.555 227.402 771.935 227.021 772.411 227.021C772.887 227.021 773.267 227.402 773.267 227.878Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.267 213.701C773.267 214.176 772.887 214.557 772.411 214.557C771.935 214.557 771.555 214.176 771.555 213.701C771.555 213.225 771.935 212.844 772.411 212.844C772.887 212.844 773.267 213.225 773.267 213.701Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.939 217.221C753.939 217.697 753.559 218.077 753.083 218.077C752.607 218.077 752.227 217.697 752.227 217.221C752.227 216.745 752.607 216.365 753.083 216.365C753.654 216.46 753.939 216.84 753.939 217.221Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.33 212.083C754.33 212.559 753.949 212.939 753.473 212.939C752.998 212.939 752.617 212.559 752.617 212.083C752.617 211.607 752.998 211.227 753.473 211.227C754.044 211.227 754.33 211.607 754.33 212.083Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.502 205.042C756.502 205.518 756.121 205.898 755.645 205.898C755.17 205.898 754.789 205.518 754.789 205.042C754.789 204.566 755.17 204.186 755.645 204.186C756.121 204.281 756.502 204.566 756.502 205.042Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.65 200.57C763.65 201.046 763.27 201.427 762.794 201.427C762.318 201.427 761.938 201.046 761.938 200.57C761.938 200.094 762.318 199.714 762.794 199.714C763.27 199.809 763.65 200.094 763.65 200.57Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.611 196.098C752.611 196.574 752.23 196.955 751.755 196.955C751.279 196.955 750.898 196.574 750.898 196.098C750.898 195.623 751.279 195.242 751.755 195.242C752.23 195.242 752.611 195.623 752.611 196.098Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.041 192.863C756.041 193.339 755.66 193.719 755.184 193.719C754.709 193.719 754.328 193.339 754.328 192.863C754.328 192.387 754.709 192.007 755.184 192.007C755.66 192.007 756.041 192.387 756.041 192.863Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.236 188.772C750.236 189.248 749.855 189.628 749.38 189.628C748.904 189.628 748.523 189.248 748.523 188.772C748.523 188.296 748.904 187.916 749.38 187.916C749.855 187.916 750.236 188.296 750.236 188.772Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.556 186.679C757.556 187.154 757.176 187.535 756.7 187.535C756.224 187.535 755.844 187.154 755.844 186.679C755.844 186.203 756.224 185.822 756.7 185.822C757.176 185.917 757.556 186.298 757.556 186.679Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.689 189.818C774.689 190.294 774.309 190.675 773.833 190.675C773.357 190.675 772.977 190.294 772.977 189.818C772.977 189.343 773.357 188.962 773.833 188.962C774.309 188.962 774.689 189.343 774.689 189.818Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.197 186.393C784.197 186.869 783.816 187.25 783.341 187.25C782.865 187.25 782.484 186.869 782.484 186.393C782.484 185.917 782.865 185.537 783.341 185.537C783.816 185.537 784.197 185.917 784.197 186.393Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.283 183.444C747.283 183.919 746.902 184.3 746.427 184.3C745.951 184.3 745.57 183.919 745.57 183.444C745.57 182.968 745.951 182.587 746.427 182.587C746.902 182.587 747.283 182.968 747.283 183.444Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.541 179.352C771.541 179.828 771.16 180.209 770.684 180.209C770.209 180.209 769.828 179.828 769.828 179.352C769.828 178.877 770.209 178.496 770.684 178.496C771.16 178.591 771.541 178.877 771.541 179.352Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.205 174.024C782.205 174.5 781.824 174.88 781.349 174.88C780.873 174.88 780.492 174.5 780.492 174.024C780.492 173.548 780.873 173.168 781.349 173.168C781.824 173.263 782.205 173.643 782.205 174.024Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.33 173.263C752.33 173.739 751.949 174.119 751.474 174.119C750.998 174.119 750.617 173.739 750.617 173.263C750.617 172.787 750.998 172.406 751.474 172.406C752.044 172.406 752.33 172.787 752.33 173.263Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.809 167.459C747.282 167.459 747.666 167.075 747.666 166.603C747.666 166.13 747.282 165.746 746.809 165.746C746.337 165.746 745.953 166.13 745.953 166.603C745.953 167.075 746.337 167.459 746.809 167.459Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.005 167.459C741.478 167.459 741.861 167.075 741.861 166.603C741.861 166.13 741.478 165.746 741.005 165.746C740.532 165.746 740.148 166.13 740.148 166.603C740.148 167.075 740.532 167.459 741.005 167.459Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.049 56.7072C689.049 57.183 688.668 57.5635 688.192 57.5635C687.717 57.5635 687.336 57.183 687.336 56.7072C687.336 56.2315 687.717 55.8509 688.192 55.8509C688.668 55.946 689.049 56.2315 689.049 56.7072Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.013 78.5911C680.486 78.5911 680.869 78.2077 680.869 77.7348C680.869 77.2619 680.486 76.8785 680.013 76.8785C679.54 76.8785 679.156 77.2619 679.156 77.7348C679.156 78.2077 679.54 78.5911 680.013 78.5911Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.072 82.8727C669.072 83.3485 668.691 83.7291 668.216 83.7291C667.74 83.7291 667.359 83.3485 667.359 82.8727C667.359 82.397 667.74 82.0164 668.216 82.0164C668.691 82.0164 669.072 82.397 669.072 82.8727Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.885 87.0592C670.885 87.535 670.504 87.9155 670.028 87.9155C669.552 87.9155 669.172 87.535 669.172 87.0592C669.172 86.5835 669.552 86.2029 670.028 86.2029C670.504 86.2029 670.885 86.5835 670.885 87.0592Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.775 74.3095C678.775 74.7852 678.395 75.1658 677.919 75.1658C677.443 75.1658 677.062 74.7852 677.062 74.3095C677.062 73.8338 677.443 73.4532 677.919 73.4532C678.395 73.4532 678.775 73.8338 678.775 74.3095Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.927 92.0069C672.4 92.0069 672.783 91.6235 672.783 91.1506C672.783 90.6777 672.4 90.2943 671.927 90.2943C671.454 90.2943 671.07 90.6777 671.07 91.1506C671.07 91.6235 671.454 92.0069 671.927 92.0069Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.27 105.708C659.743 105.708 660.127 105.325 660.127 104.852C660.127 104.379 659.743 103.995 659.27 103.995C658.797 103.995 658.414 104.379 658.414 104.852C658.414 105.325 658.797 105.708 659.27 105.708Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.642 110.085C667.642 110.561 667.262 110.941 666.786 110.941C666.31 110.941 665.93 110.561 665.93 110.085C665.93 109.609 666.31 109.229 666.786 109.229C667.357 109.324 667.642 109.704 667.642 110.085Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.27 121.883C659.743 121.883 660.127 121.5 660.127 121.027C660.127 120.554 659.743 120.171 659.27 120.171C658.797 120.171 658.414 120.554 658.414 121.027C658.414 121.5 658.797 121.883 659.27 121.883Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.744 126.545C659.744 127.021 659.363 127.402 658.888 127.402C658.412 127.402 658.031 127.021 658.031 126.545C658.031 126.07 658.412 125.689 658.888 125.689C659.363 125.689 659.744 126.07 659.744 126.545Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.747 132.825C660.22 132.825 660.603 132.442 660.603 131.969C660.603 131.496 660.22 131.112 659.747 131.112C659.274 131.112 658.891 131.496 658.891 131.969C658.891 132.442 659.274 132.825 659.747 132.825Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.989 134.633C665.462 134.633 665.845 134.25 665.845 133.777C665.845 133.304 665.462 132.92 664.989 132.92C664.516 132.92 664.133 133.304 664.133 133.777C664.133 134.25 664.516 134.633 664.989 134.633Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.603 148.62C662.603 149.095 662.223 149.476 661.747 149.476C661.271 149.476 660.891 149.095 660.891 148.62C660.891 148.144 661.271 147.763 661.747 147.763C662.223 147.763 662.603 148.144 662.603 148.62Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.434 147.954C691.907 147.954 692.291 147.57 692.291 147.097C692.291 146.624 691.907 146.241 691.434 146.241C690.962 146.241 690.578 146.624 690.578 147.097C690.578 147.57 690.962 147.954 691.434 147.954Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.716 147.954C700.189 147.954 700.572 147.57 700.572 147.097C700.572 146.624 700.189 146.241 699.716 146.241C699.243 146.241 698.859 146.624 698.859 147.097C698.859 147.57 699.243 147.954 699.716 147.954Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.213 147.097C723.213 147.573 722.832 147.954 722.356 147.954C721.881 147.954 721.5 147.573 721.5 147.097C721.5 146.622 721.881 146.241 722.356 146.241C722.832 146.336 723.213 146.717 723.213 147.097Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.705 154.233C701.705 154.709 701.324 155.09 700.849 155.09C700.373 155.09 699.992 154.709 699.992 154.233C699.992 153.758 700.373 153.377 700.849 153.377C701.419 153.377 701.705 153.758 701.705 154.233Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.674 154.233C688.674 154.709 688.293 155.09 687.817 155.09C687.342 155.09 686.961 154.709 686.961 154.233C686.961 153.758 687.342 153.377 687.817 153.377C688.293 153.377 688.674 153.758 688.674 154.233Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.302 155.09C678.775 155.09 679.158 154.706 679.158 154.233C679.158 153.76 678.775 153.377 678.302 153.377C677.829 153.377 677.445 153.76 677.445 154.233C677.445 154.706 677.829 155.09 678.302 155.09Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.783 158.8C672.783 159.276 672.402 159.657 671.927 159.657C671.451 159.657 671.07 159.276 671.07 158.8C671.07 158.325 671.451 157.944 671.927 157.944C672.402 158.039 672.783 158.325 672.783 158.8Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.431 166.793C693.431 167.269 693.051 167.649 692.575 167.649C692.099 167.649 691.719 167.269 691.719 166.793C691.719 166.317 692.099 165.936 692.575 165.936C693.051 166.032 693.431 166.412 693.431 166.793Z",
    fill: "#00A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.544 169.362C672.017 169.362 672.4 168.978 672.4 168.505C672.4 168.033 672.017 167.649 671.544 167.649C671.071 167.649 670.688 168.033 670.688 168.505C670.688 168.978 671.071 169.362 671.544 169.362Z",
    fill: "#00A0FC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M790.861 142.435H649.377C646.998 142.435 645 144.433 645 146.812V241.293C645 243.672 646.903 245.67 649.377 245.67H790.861C793.24 245.67 795.238 243.767 795.238 241.293V146.812C795.238 144.433 793.24 142.435 790.861 142.435ZM735.295 225.879H705.038C704.277 225.879 703.706 225.118 703.896 224.357L711.223 189.818C707.417 187.059 704.943 182.587 704.943 177.449C704.943 168.696 712.174 161.75 721.023 162.131C728.92 162.511 735.295 168.981 735.58 176.878C735.771 182.207 733.297 186.869 729.301 189.723L736.627 224.262C736.627 225.213 736.056 225.879 735.295 225.879Z",
    fill: "url(#paint0_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.587 142.435V112.178C786.587 75.4512 756.805 45.67 720.078 45.67C683.351 45.67 653.57 75.4512 653.57 112.178V142.435H671.839V111.132C671.839 84.4902 693.437 62.8917 720.078 62.8917C746.72 62.8917 768.318 84.4902 768.318 111.132V142.435H786.587Z",
    fill: "url(#paint1_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.861 245.575H649.377C646.998 245.575 645 243.672 645 241.198V146.717C645 144.338 646.903 142.34 649.377 142.34H790.861C793.24 142.34 795.238 144.243 795.238 146.717V241.198C795.238 243.672 793.24 245.575 790.861 245.575Z",
    stroke: "#00D0FF",
    strokeWidth: 3.74026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.701 112.178V140.565H770.173V111.132C770.173 83.4575 747.737 61.0217 720.063 61.0217C692.389 61.0217 669.953 83.4575 669.953 111.132V140.565H655.425V112.178C655.425 76.4842 684.369 47.5403 720.063 47.5403C755.757 47.5403 784.701 76.4842 784.701 112.178Z",
    fill: "url(#paint2_linear_1576_69345)",
    stroke: "#00D0FF",
    strokeWidth: 3.74026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.431 224.452L729.105 189.914C733.006 187.059 735.575 182.302 735.385 177.069C735.099 169.171 728.725 162.701 720.827 162.321C711.979 161.94 704.747 168.886 704.747 177.64C704.747 182.682 707.221 187.154 711.027 190.009L703.701 224.547C703.51 225.308 704.081 225.974 704.938 225.974H735.195C736.051 225.879 736.622 225.118 736.431 224.452Z",
    stroke: "#00D0FF",
    strokeWidth: 3.74026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.023 253.222C601.023 254.418 600.027 255.415 598.831 255.415C597.735 255.415 596.838 254.618 596.638 253.621H458.205L449.235 262.591H-13.0245C-13.2239 263.587 -14.1208 264.385 -15.2172 264.385C-16.4131 264.385 -17.4098 263.388 -17.4098 262.192C-17.4098 260.996 -16.4131 260 -15.2172 260C-14.1208 260 -13.2239 260.697 -13.0245 261.694H448.836L457.806 252.724H596.638C596.838 251.727 597.735 250.93 598.831 250.93C600.027 251.03 601.023 252.026 601.023 253.222ZM-14.0212 262.292C-14.0212 261.594 -14.6192 261.096 -15.2172 261.096C-15.9148 261.096 -16.4131 261.694 -16.4131 262.292C-16.4131 262.989 -15.8151 263.488 -15.2172 263.488C-14.6192 263.488 -14.0212 262.89 -14.0212 262.292ZM600.027 253.222C600.027 252.525 599.429 252.026 598.831 252.026C598.133 252.026 597.635 252.624 597.635 253.222C597.635 253.92 598.233 254.418 598.831 254.418C599.528 254.518 600.027 253.92 600.027 253.222Z",
    fill: "url(#paint3_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.766 210.865C496.67 210.865 495.673 211.463 495.175 212.36H416.739L374.781 170.402H307.607V173.392H373.485L415.444 215.35H495.075C495.573 216.247 496.57 216.845 497.666 216.845C499.361 216.845 500.656 215.45 500.656 213.855C500.656 212.26 499.46 210.865 497.766 210.865Z",
    fill: "url(#paint4_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.766 210.865C496.67 210.865 495.673 211.463 495.175 212.36H416.739L374.781 170.402H307.607V173.392H373.485L415.444 215.35H495.075C495.573 216.247 496.57 216.845 497.666 216.845C499.361 216.845 500.656 215.45 500.656 213.855C500.656 212.26 499.46 210.865 497.766 210.865Z",
    fill: "url(#paint5_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.766 210.865C496.67 210.865 495.673 211.463 495.175 212.36H416.739L374.781 170.402L-17.7891 170.402V173.392H373.485L415.444 215.35H495.075C495.573 216.247 496.57 216.845 497.666 216.845C499.361 216.845 500.656 215.45 500.656 213.855C500.656 212.26 499.46 210.865 497.766 210.865Z",
    fill: "url(#paint6_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.174 136.915C556.078 136.915 555.081 137.513 554.583 138.41H505.15L495.482 148.077H-11.6925C-12.1908 147.18 -13.1874 146.582 -14.2838 146.582C-15.978 146.582 -17.2737 147.977 -17.2737 149.572C-17.2737 151.166 -15.8784 152.562 -14.2838 152.562C-13.1874 152.562 -12.1908 151.964 -11.6925 151.067H496.678L506.346 141.399H554.583C555.081 142.296 556.078 142.894 557.174 142.894C558.868 142.894 560.164 141.499 560.164 139.904C560.164 138.31 558.769 136.915 557.174 136.915Z",
    fill: "url(#paint7_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.617 119.673C484.617 120.869 483.621 121.865 482.425 121.865C481.328 121.865 480.431 121.068 480.232 120.071H8.79977L-18.0098 146.881L-18.7075 146.183L8.40115 119.075H480.232C480.431 118.078 481.328 117.38 482.425 117.38C483.621 117.38 484.617 118.377 484.617 119.673ZM483.621 119.673C483.621 118.975 483.023 118.477 482.425 118.477C481.827 118.477 481.229 119.075 481.229 119.673C481.229 120.37 481.827 120.869 482.425 120.869C483.023 120.869 483.621 120.37 483.621 119.673Z",
    fill: "url(#paint8_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.672 104.922C524.672 106.118 523.675 107.115 522.479 107.115C521.383 107.115 520.486 106.318 520.287 105.321H-17.7927V104.324H520.287C520.486 103.328 521.383 102.63 522.479 102.63C523.576 102.73 524.672 103.726 524.672 104.922ZM523.675 104.922C523.675 104.225 523.077 103.726 522.479 103.726C521.881 103.726 521.283 104.324 521.283 104.922C521.283 105.52 521.881 106.118 522.479 106.118C523.077 106.118 523.675 105.62 523.675 104.922Z",
    fill: "url(#paint9_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.25 79.807C533.25 81.0029 532.253 81.9996 531.057 81.9996C529.961 81.9996 529.064 81.2023 528.865 80.3053H375.382L335.816 119.872H199.475V118.875H335.317L374.984 79.3086H528.765C528.964 78.312 529.861 77.5147 530.958 77.5147C532.253 77.5147 533.25 78.5113 533.25 79.807ZM532.253 79.807C532.253 79.1093 531.655 78.611 531.057 78.611C530.459 78.611 529.861 79.209 529.861 79.807C529.861 80.5046 530.459 81.0029 531.057 81.0029C531.655 81.0029 532.253 80.5046 532.253 79.807Z",
    fill: "url(#paint10_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.25 79.807C533.25 81.0029 532.253 81.9996 531.057 81.9996C529.961 81.9996 529.064 81.2023 528.865 80.3053H375.382L335.816 119.872H-18.5247V118.875H335.317L374.984 79.3086H528.765C528.964 78.312 529.861 77.5147 530.958 77.5147C532.253 77.5147 533.25 78.5113 533.25 79.807ZM532.253 79.807C532.253 79.1093 531.655 78.611 531.057 78.611C530.459 78.611 529.861 79.209 529.861 79.807C529.861 80.5046 530.459 81.0029 531.057 81.0029C531.655 81.0029 532.253 80.5046 532.253 79.807Z",
    fill: "url(#paint11_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.625 127.845C600.625 129.041 599.628 130.038 598.432 130.038C597.336 130.038 596.439 129.24 596.24 128.343H442.259L425.316 145.286H313.294V144.29H424.917L441.86 127.347H596.14C596.339 126.35 597.236 125.553 598.333 125.553C599.628 125.652 600.625 126.649 600.625 127.845ZM599.628 127.845C599.628 127.147 599.03 126.649 598.432 126.649C597.735 126.649 597.236 127.247 597.236 127.845C597.236 128.543 597.834 129.041 598.432 129.041C599.03 129.141 599.628 128.543 599.628 127.845Z",
    fill: "url(#paint12_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.625 127.845C600.625 129.041 599.628 130.038 598.432 130.038C597.336 130.038 596.439 129.24 596.24 128.343H442.259L425.316 145.286H313.294V144.29H424.917L441.86 127.347H596.14C596.339 126.35 597.236 125.553 598.333 125.553C599.628 125.652 600.625 126.649 600.625 127.845ZM599.628 127.845C599.628 127.147 599.03 126.649 598.432 126.649C597.735 126.649 597.236 127.247 597.236 127.845C597.236 128.543 597.834 129.041 598.432 129.041C599.03 129.141 599.628 128.543 599.628 127.845Z",
    fill: "url(#paint13_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.539 127.928C600.539 129.124 599.542 130.12 598.346 130.12C597.25 130.12 596.353 129.323 596.154 128.426H442.173L425.23 145.369H-17.7924V144.372H424.831L441.774 127.429H596.054C596.254 126.433 597.15 125.635 598.247 125.635C599.542 125.735 600.539 126.732 600.539 127.928ZM599.542 127.928C599.542 127.23 598.944 126.732 598.346 126.732C597.649 126.732 597.15 127.33 597.15 127.928C597.15 128.625 597.748 129.124 598.346 129.124C598.944 129.223 599.542 128.625 599.542 127.928Z",
    fill: "url(#paint14_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 49.5092C607 50.7051 606.003 51.7018 604.807 51.7018C603.711 51.7018 602.814 50.9045 602.615 50.0075H525.176L503.848 28.6794H-13.076C-13.2754 29.676 -14.1723 30.4733 -15.2686 30.4733C-16.4646 30.4733 -17.4612 29.4767 -17.4612 28.2807C-17.4612 27.0848 -16.4646 26.0881 -15.2686 26.0881C-14.1723 26.0881 -13.2754 26.8854 -13.076 27.8821H504.147L525.475 49.0109H602.515C602.714 48.0142 603.611 47.2169 604.708 47.2169C606.003 47.2169 607 48.3132 607 49.5092ZM-14.0726 28.1811C-14.0726 27.4834 -14.6707 26.9851 -15.2686 26.9851C-15.9662 26.9851 -16.4645 27.5831 -16.4645 28.1811C-16.4645 28.8787 -15.8666 29.377 -15.2686 29.377C-14.571 29.377 -14.0726 28.8787 -14.0726 28.1811ZM606.003 49.5092C606.003 48.8115 605.405 48.3132 604.807 48.3132C604.11 48.3132 603.611 48.9112 603.611 49.5092C603.611 50.2068 604.209 50.7051 604.807 50.7051C605.405 50.7051 606.003 50.2068 606.003 49.5092Z",
    fill: "url(#paint15_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.023 188.142C599.023 189.338 598.027 190.334 596.831 190.334C595.735 190.334 594.838 189.537 594.638 188.64H543.112L512.316 157.844H-17.7891V156.847L512.714 156.847L543.411 187.643H594.539C594.738 186.647 595.635 185.849 596.731 185.849C598.027 185.849 599.023 186.846 599.023 188.142ZM598.027 188.142C598.027 187.444 597.429 186.946 596.831 186.946C596.233 186.946 595.635 187.544 595.635 188.142C595.635 188.839 596.233 189.338 596.831 189.338C597.429 189.338 598.027 188.839 598.027 188.142Z",
    fill: "url(#paint16_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.727 186.547C508.727 187.743 507.73 188.74 506.534 188.74C505.438 188.74 504.541 187.943 504.341 186.946H471.851L462.084 177.179H419.527C419.328 178.175 418.431 178.873 417.335 178.873C416.139 178.873 415.142 177.877 415.142 176.681C415.142 175.485 416.139 174.488 417.335 174.488C418.431 174.488 419.328 175.285 419.527 176.282H462.482L472.249 186.049H504.341C504.541 185.052 505.438 184.255 506.534 184.255C507.73 184.355 508.727 185.351 508.727 186.547ZM418.63 176.78C418.63 176.083 418.032 175.584 417.434 175.584C416.836 175.584 416.238 176.182 416.238 176.78C416.238 177.478 416.836 177.976 417.434 177.976C418.032 177.976 418.63 177.478 418.63 176.78ZM507.73 186.547C507.73 185.85 507.132 185.351 506.534 185.351C505.936 185.351 505.338 185.949 505.338 186.547C505.338 187.245 505.936 187.743 506.534 187.743C507.132 187.743 507.73 187.245 507.73 186.547Z",
    fill: "url(#paint17_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.727 186.547C508.727 187.743 507.73 188.74 506.534 188.74C505.438 188.74 504.541 187.943 504.341 186.946H471.851L462.084 177.179H419.527C419.328 178.175 418.431 178.873 417.335 178.873C416.139 178.873 415.142 177.877 415.142 176.681C415.142 175.485 416.139 174.488 417.335 174.488C418.431 174.488 419.328 175.285 419.527 176.282H462.482L472.249 186.049H504.341C504.541 185.052 505.438 184.255 506.534 184.255C507.73 184.355 508.727 185.351 508.727 186.547ZM418.63 176.78C418.63 176.083 418.032 175.584 417.434 175.584C416.836 175.584 416.238 176.182 416.238 176.78C416.238 177.478 416.836 177.976 417.434 177.976C418.032 177.976 418.63 177.478 418.63 176.78ZM507.73 186.547C507.73 185.85 507.132 185.351 506.534 185.351C505.936 185.351 505.338 185.949 505.338 186.547C505.338 187.245 505.936 187.743 506.534 187.743C507.132 187.743 507.73 187.245 507.73 186.547Z",
    fill: "url(#paint18_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.742 218.938C534.742 220.134 533.746 221.131 532.55 221.131C531.453 221.131 530.556 220.333 530.357 219.337H-5.72467L-19.0796 205.982L-18.382 205.284L-5.32599 218.44H530.257C530.457 217.443 531.354 216.745 532.45 216.745C533.746 216.646 534.742 217.642 534.742 218.938ZM533.746 218.938C533.746 218.24 533.148 217.742 532.55 217.742C531.852 217.742 531.354 218.34 531.354 218.938C531.354 219.636 531.952 220.134 532.55 220.134C533.148 220.134 533.746 219.536 533.746 218.938Z",
    fill: "url(#paint19_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.734 224.22C450.734 225.416 449.738 226.413 448.542 226.413C447.445 226.413 446.548 225.615 446.349 224.719H377.681L365.522 236.878H-13.2174C-13.4168 237.874 -14.3137 238.671 -15.41 238.671C-16.606 238.671 -17.6026 237.675 -17.6026 236.479C-17.6026 235.283 -16.606 234.286 -15.41 234.286C-14.3137 234.286 -13.4168 235.084 -13.2174 236.08H365.123L377.282 223.921H446.349C446.548 222.925 447.445 222.127 448.542 222.127C449.738 221.928 450.734 222.925 450.734 224.22ZM-14.1144 236.28C-14.1144 235.582 -14.7124 235.084 -15.3104 235.084C-16.008 235.084 -16.5063 235.682 -16.5063 236.28C-16.5063 236.977 -15.9084 237.476 -15.3104 237.476C-14.7124 237.575 -14.1144 236.977 -14.1144 236.28ZM449.738 224.22C449.738 223.523 449.14 223.024 448.542 223.024C447.844 223.024 447.346 223.622 447.346 224.22C447.346 224.918 447.944 225.416 448.542 225.416C449.239 225.416 449.738 224.918 449.738 224.22Z",
    fill: "url(#paint20_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.789 207.277C491.789 208.473 490.792 209.47 489.596 209.47C488.5 209.47 487.603 208.673 487.404 207.676H420.23L408.869 196.514H-17.7891V195.517H409.267L420.529 206.779H487.304C487.504 205.782 488.4 205.085 489.497 205.085C490.792 205.085 491.789 206.081 491.789 207.277ZM490.792 207.277C490.792 206.58 490.194 206.081 489.596 206.081C488.899 206.081 488.4 206.679 488.4 207.277C488.4 207.975 488.998 208.473 489.596 208.473C490.194 208.573 490.792 207.975 490.792 207.277Z",
    fill: "url(#paint21_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.219 59.0769C571.219 61.5685 569.126 63.6615 566.634 63.6615C564.641 63.6615 562.947 62.3658 562.349 60.5719H498.863L484.411 75.0232H-18.2929V72.0332H483.215L497.567 57.582H562.349C562.947 55.788 564.641 54.4924 566.634 54.4924C569.126 54.4924 571.219 56.5853 571.219 59.0769ZM568.229 59.0769C568.229 58.1799 567.531 57.4823 566.634 57.4823C565.737 57.4823 565.04 58.1799 565.04 59.0769C565.04 59.9739 565.737 60.6715 566.634 60.6715C567.531 60.6715 568.229 59.9739 568.229 59.0769Z",
    fill: "url(#paint22_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.079 63.8608C495.082 63.8608 494.185 64.4588 493.786 65.3557H452.326L424.52 93.162H20.6835L-19.5808 133.426L-18.1854 134.822L21.5805 95.0556H425.317L453.124 67.2494H493.786C494.185 68.1463 495.082 68.844 496.079 68.844C497.474 68.844 498.57 67.7477 498.57 66.3524C498.57 64.9571 497.474 63.8608 496.079 63.8608Z",
    fill: "url(#paint23_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.962 193.922C529.965 193.922 529.068 194.52 528.669 195.417H421.231L388.741 162.927L-17.7891 162.927V164.92H387.944L420.334 197.51H528.669C529.068 198.407 529.965 199.005 530.962 199.005C532.357 199.005 533.453 197.909 533.453 196.514C533.453 195.118 532.357 193.922 530.962 193.922Z",
    fill: "url(#paint24_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.039 230.001C507.039 231.496 505.843 232.692 504.348 232.692C503.252 232.692 502.255 231.994 501.857 230.997H-1.32257L-19.2621 213.058L-17.8668 211.663L-0.525269 229.004H501.857C502.255 228.007 503.252 227.409 504.348 227.409C505.843 227.31 507.039 228.506 507.039 230.001ZM505.544 230.001C505.544 229.403 505.046 228.805 504.348 228.805C503.75 228.805 503.152 229.303 503.152 230.001C503.152 230.599 503.65 231.197 504.348 231.197C504.946 231.197 505.544 230.698 505.544 230.001Z",
    fill: "url(#paint25_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.445 100.936C592.445 102.132 591.449 103.128 590.253 103.128C589.156 103.128 588.259 102.331 588.06 101.334H511.717L502.748 110.304H-13.4896C-13.689 111.301 -14.5859 112.098 -15.6823 112.098C-16.8782 112.098 -17.8749 111.102 -17.8749 109.906C-17.8749 108.71 -16.8782 107.713 -15.6823 107.713C-14.5859 107.713 -13.689 108.411 -13.4896 109.407H502.249L511.219 100.438H587.96C588.16 99.4409 589.057 98.6436 590.153 98.6436C591.449 98.6436 592.445 99.6402 592.445 100.936ZM-14.4863 109.906C-14.4863 109.208 -15.0843 108.71 -15.6823 108.71C-16.3799 108.71 -16.8782 109.308 -16.8782 109.906C-16.8782 110.603 -16.2802 111.102 -15.6823 111.102C-15.0843 111.201 -14.4863 110.603 -14.4863 109.906ZM591.449 100.936C591.449 100.238 590.851 99.7398 590.253 99.7398C589.655 99.7398 589.057 100.338 589.057 100.936C589.057 101.633 589.655 102.132 590.253 102.132C590.851 102.132 591.449 101.633 591.449 100.936Z",
    fill: "url(#paint26_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.977 253.222C838.977 254.418 839.973 255.415 841.169 255.415C842.265 255.415 843.162 254.618 843.362 253.621H981.795L990.765 262.591H1453.02C1453.22 263.587 1454.12 264.385 1455.22 264.385C1456.41 264.385 1457.41 263.388 1457.41 262.192C1457.41 260.996 1456.41 260 1455.22 260C1454.12 260 1453.22 260.697 1453.02 261.694H991.164L982.194 252.724H843.362C843.162 251.727 842.265 250.93 841.169 250.93C839.973 251.03 838.977 252.026 838.977 253.222ZM1454.02 262.292C1454.02 261.594 1454.62 261.096 1455.22 261.096C1455.91 261.096 1456.41 261.694 1456.41 262.292C1456.41 262.989 1455.82 263.488 1455.22 263.488C1454.62 263.488 1454.02 262.89 1454.02 262.292ZM839.973 253.222C839.973 252.525 840.571 252.026 841.169 252.026C841.867 252.026 842.365 252.624 842.365 253.222C842.365 253.92 841.767 254.418 841.169 254.418C840.472 254.518 839.973 253.92 839.973 253.222Z",
    fill: "url(#paint27_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.234 210.865C943.33 210.865 944.327 211.463 944.825 212.36H1023.26L1065.22 170.402H1132.39V173.392H1066.52L1024.56 215.35H944.925C944.427 216.247 943.43 216.845 942.334 216.845C940.639 216.845 939.344 215.45 939.344 213.855C939.344 212.26 940.54 210.865 942.234 210.865Z",
    fill: "url(#paint28_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.234 210.865C943.33 210.865 944.327 211.463 944.825 212.36H1023.26L1065.22 170.402H1132.39V173.392H1066.52L1024.56 215.35H944.925C944.427 216.247 943.43 216.845 942.334 216.845C940.639 216.845 939.344 215.45 939.344 213.855C939.344 212.26 940.54 210.865 942.234 210.865Z",
    fill: "url(#paint29_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.234 210.865C943.33 210.865 944.327 211.463 944.825 212.36H1023.26L1065.22 170.402L1457.79 170.402V173.392H1066.52L1024.56 215.35H944.925C944.427 216.247 943.43 216.845 942.334 216.845C940.639 216.845 939.344 215.45 939.344 213.855C939.344 212.26 940.54 210.865 942.234 210.865Z",
    fill: "url(#paint30_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.826 136.915C883.922 136.915 884.919 137.513 885.417 138.41H934.85L944.518 148.077H1451.69C1452.19 147.18 1453.19 146.582 1454.28 146.582C1455.98 146.582 1457.27 147.977 1457.27 149.572C1457.27 151.166 1455.88 152.562 1454.28 152.562C1453.19 152.562 1452.19 151.964 1451.69 151.067H943.322L933.654 141.399H885.417C884.919 142.296 883.922 142.894 882.826 142.894C881.132 142.894 879.836 141.499 879.836 139.904C879.836 138.31 881.231 136.915 882.826 136.915Z",
    fill: "url(#paint31_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.383 119.673C955.383 120.869 956.379 121.865 957.575 121.865C958.672 121.865 959.569 121.068 959.768 120.071H1431.2L1458.01 146.881L1458.71 146.183L1431.6 119.075H959.768C959.569 118.078 958.672 117.38 957.575 117.38C956.379 117.38 955.383 118.377 955.383 119.673ZM956.379 119.673C956.379 118.975 956.977 118.477 957.575 118.477C958.173 118.477 958.771 119.075 958.771 119.673C958.771 120.37 958.173 120.869 957.575 120.869C956.977 120.869 956.379 120.37 956.379 119.673Z",
    fill: "url(#paint32_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.328 104.922C915.328 106.118 916.325 107.115 917.521 107.115C918.617 107.115 919.514 106.318 919.713 105.321H1457.79V104.324H919.713C919.514 103.328 918.617 102.63 917.521 102.63C916.424 102.73 915.328 103.726 915.328 104.922ZM916.325 104.922C916.325 104.225 916.923 103.726 917.521 103.726C918.119 103.726 918.717 104.324 918.717 104.922C918.717 105.52 918.119 106.118 917.521 106.118C916.923 106.118 916.325 105.62 916.325 104.922Z",
    fill: "url(#paint33_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.75 79.807C906.75 81.0029 907.747 81.9996 908.943 81.9996C910.039 81.9996 910.936 81.2023 911.135 80.3053H1064.62L1104.18 119.872H1240.52V118.875H1104.68L1065.02 79.3086H911.235C911.036 78.312 910.139 77.5147 909.042 77.5147C907.747 77.5147 906.75 78.5113 906.75 79.807ZM907.747 79.807C907.747 79.1093 908.345 78.611 908.943 78.611C909.541 78.611 910.139 79.209 910.139 79.807C910.139 80.5046 909.541 81.0029 908.943 81.0029C908.345 81.0029 907.747 80.5046 907.747 79.807Z",
    fill: "url(#paint34_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.75 79.807C906.75 81.0029 907.747 81.9996 908.943 81.9996C910.039 81.9996 910.936 81.2023 911.135 80.3053H1064.62L1104.18 119.872H1458.52V118.875H1104.68L1065.02 79.3086H911.235C911.036 78.312 910.139 77.5147 909.042 77.5147C907.747 77.5147 906.75 78.5113 906.75 79.807ZM907.747 79.807C907.747 79.1093 908.345 78.611 908.943 78.611C909.541 78.611 910.139 79.209 910.139 79.807C910.139 80.5046 909.541 81.0029 908.943 81.0029C908.345 81.0029 907.747 80.5046 907.747 79.807Z",
    fill: "url(#paint35_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.375 127.845C839.375 129.041 840.372 130.038 841.568 130.038C842.664 130.038 843.561 129.24 843.76 128.343H997.741L1014.68 145.286H1126.71V144.29H1015.08L998.14 127.347H843.86C843.661 126.35 842.764 125.553 841.667 125.553C840.372 125.652 839.375 126.649 839.375 127.845ZM840.372 127.845C840.372 127.147 840.97 126.649 841.568 126.649C842.265 126.649 842.764 127.247 842.764 127.845C842.764 128.543 842.166 129.041 841.568 129.041C840.97 129.141 840.372 128.543 840.372 127.845Z",
    fill: "url(#paint36_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.375 127.845C839.375 129.041 840.372 130.038 841.568 130.038C842.664 130.038 843.561 129.24 843.76 128.343H997.741L1014.68 145.286H1126.71V144.29H1015.08L998.14 127.347H843.86C843.661 126.35 842.764 125.553 841.667 125.553C840.372 125.652 839.375 126.649 839.375 127.845ZM840.372 127.845C840.372 127.147 840.97 126.649 841.568 126.649C842.265 126.649 842.764 127.247 842.764 127.845C842.764 128.543 842.166 129.041 841.568 129.041C840.97 129.141 840.372 128.543 840.372 127.845Z",
    fill: "url(#paint37_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.461 127.928C839.461 129.124 840.458 130.12 841.654 130.12C842.75 130.12 843.647 129.323 843.846 128.426H997.827L1014.77 145.369H1457.79V144.372H1015.17L998.226 127.429H843.946C843.746 126.433 842.85 125.635 841.753 125.635C840.458 125.735 839.461 126.732 839.461 127.928ZM840.458 127.928C840.458 127.23 841.056 126.732 841.654 126.732C842.351 126.732 842.85 127.33 842.85 127.928C842.85 128.625 842.252 129.124 841.654 129.124C841.056 129.223 840.458 128.625 840.458 127.928Z",
    fill: "url(#paint38_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833 49.5092C833 50.7051 833.997 51.7018 835.193 51.7018C836.289 51.7018 837.186 50.9045 837.385 50.0075H914.824L936.152 28.6794H1453.08C1453.28 29.676 1454.17 30.4733 1455.27 30.4733C1456.46 30.4733 1457.46 29.4767 1457.46 28.2807C1457.46 27.0848 1456.46 26.0881 1455.27 26.0881C1454.17 26.0881 1453.28 26.8854 1453.08 27.8821H935.853L914.525 49.0109H837.485C837.286 48.0142 836.389 47.2169 835.292 47.2169C833.997 47.2169 833 48.3132 833 49.5092ZM1454.07 28.1811C1454.07 27.4834 1454.67 26.9851 1455.27 26.9851C1455.97 26.9851 1456.46 27.5831 1456.46 28.1811C1456.46 28.8787 1455.87 29.377 1455.27 29.377C1454.57 29.377 1454.07 28.8787 1454.07 28.1811ZM833.997 49.5092C833.997 48.8115 834.595 48.3132 835.193 48.3132C835.89 48.3132 836.389 48.9112 836.389 49.5092C836.389 50.2068 835.791 50.7051 835.193 50.7051C834.595 50.7051 833.997 50.2068 833.997 49.5092Z",
    fill: "url(#paint39_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.977 188.142C840.977 189.338 841.973 190.334 843.169 190.334C844.265 190.334 845.162 189.537 845.362 188.64H896.888L927.684 157.844H1457.79V156.847L927.286 156.847L896.589 187.643H845.461C845.262 186.647 844.365 185.849 843.269 185.849C841.973 185.849 840.977 186.846 840.977 188.142ZM841.973 188.142C841.973 187.444 842.571 186.946 843.169 186.946C843.767 186.946 844.365 187.544 844.365 188.142C844.365 188.839 843.767 189.338 843.169 189.338C842.571 189.338 841.973 188.839 841.973 188.142Z",
    fill: "url(#paint40_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.273 186.547C931.273 187.743 932.27 188.74 933.466 188.74C934.562 188.74 935.459 187.943 935.659 186.946H968.149L977.916 177.179H1020.47C1020.67 178.175 1021.57 178.873 1022.67 178.873C1023.86 178.873 1024.86 177.877 1024.86 176.681C1024.86 175.485 1023.86 174.488 1022.67 174.488C1021.57 174.488 1020.67 175.285 1020.47 176.282H977.518L967.751 186.049H935.659C935.459 185.052 934.562 184.255 933.466 184.255C932.27 184.355 931.273 185.351 931.273 186.547ZM1021.37 176.78C1021.37 176.083 1021.97 175.584 1022.57 175.584C1023.16 175.584 1023.76 176.182 1023.76 176.78C1023.76 177.478 1023.16 177.976 1022.57 177.976C1021.97 177.976 1021.37 177.478 1021.37 176.78ZM932.27 186.547C932.27 185.85 932.868 185.351 933.466 185.351C934.064 185.351 934.662 185.949 934.662 186.547C934.662 187.245 934.064 187.743 933.466 187.743C932.868 187.743 932.27 187.245 932.27 186.547Z",
    fill: "url(#paint41_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.273 186.547C931.273 187.743 932.27 188.74 933.466 188.74C934.562 188.74 935.459 187.943 935.659 186.946H968.149L977.916 177.179H1020.47C1020.67 178.175 1021.57 178.873 1022.67 178.873C1023.86 178.873 1024.86 177.877 1024.86 176.681C1024.86 175.485 1023.86 174.488 1022.67 174.488C1021.57 174.488 1020.67 175.285 1020.47 176.282H977.518L967.751 186.049H935.659C935.459 185.052 934.562 184.255 933.466 184.255C932.27 184.355 931.273 185.351 931.273 186.547ZM1021.37 176.78C1021.37 176.083 1021.97 175.584 1022.57 175.584C1023.16 175.584 1023.76 176.182 1023.76 176.78C1023.76 177.478 1023.16 177.976 1022.57 177.976C1021.97 177.976 1021.37 177.478 1021.37 176.78ZM932.27 186.547C932.27 185.85 932.868 185.351 933.466 185.351C934.064 185.351 934.662 185.949 934.662 186.547C934.662 187.245 934.064 187.743 933.466 187.743C932.868 187.743 932.27 187.245 932.27 186.547Z",
    fill: "url(#paint42_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.258 218.938C905.258 220.134 906.254 221.131 907.45 221.131C908.547 221.131 909.444 220.333 909.643 219.337H1445.72L1459.08 205.982L1458.38 205.284L1445.33 218.44H909.743C909.543 217.443 908.646 216.745 907.55 216.745C906.254 216.646 905.258 217.642 905.258 218.938ZM906.254 218.938C906.254 218.24 906.852 217.742 907.45 217.742C908.148 217.742 908.646 218.34 908.646 218.938C908.646 219.636 908.048 220.134 907.45 220.134C906.852 220.134 906.254 219.536 906.254 218.938Z",
    fill: "url(#paint43_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.266 224.22C989.266 225.416 990.262 226.413 991.458 226.413C992.555 226.413 993.452 225.615 993.651 224.719H1062.32L1074.48 236.878H1453.22C1453.42 237.874 1454.31 238.671 1455.41 238.671C1456.61 238.671 1457.6 237.675 1457.6 236.479C1457.6 235.283 1456.61 234.286 1455.41 234.286C1454.31 234.286 1453.42 235.084 1453.22 236.08H1074.88L1062.72 223.921H993.651C993.452 222.925 992.555 222.127 991.458 222.127C990.262 221.928 989.266 222.925 989.266 224.22ZM1454.11 236.28C1454.11 235.582 1454.71 235.084 1455.31 235.084C1456.01 235.084 1456.51 235.682 1456.51 236.28C1456.51 236.977 1455.91 237.476 1455.31 237.476C1454.71 237.575 1454.11 236.977 1454.11 236.28ZM990.262 224.22C990.262 223.523 990.86 223.024 991.458 223.024C992.156 223.024 992.654 223.622 992.654 224.22C992.654 224.918 992.056 225.416 991.458 225.416C990.761 225.416 990.262 224.918 990.262 224.22Z",
    fill: "url(#paint44_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.211 207.277C948.211 208.473 949.208 209.47 950.404 209.47C951.5 209.47 952.397 208.673 952.596 207.676H1019.77L1031.13 196.514H1457.79V195.517H1030.73L1019.47 206.779H952.696C952.496 205.782 951.6 205.085 950.503 205.085C949.208 205.085 948.211 206.081 948.211 207.277ZM949.208 207.277C949.208 206.58 949.806 206.081 950.404 206.081C951.101 206.081 951.6 206.679 951.6 207.277C951.6 207.975 951.002 208.473 950.404 208.473C949.806 208.573 949.208 207.975 949.208 207.277Z",
    fill: "url(#paint45_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.781 59.0769C868.781 61.5685 870.874 63.6615 873.366 63.6615C875.359 63.6615 877.053 62.3658 877.651 60.5719H941.137L955.589 75.0232H1458.29V72.0332H956.785L942.433 57.582H877.651C877.053 55.788 875.359 54.4924 873.366 54.4924C870.874 54.4924 868.781 56.5853 868.781 59.0769ZM871.771 59.0769C871.771 58.1799 872.469 57.4823 873.366 57.4823C874.263 57.4823 874.96 58.1799 874.96 59.0769C874.96 59.9739 874.263 60.6715 873.366 60.6715C872.469 60.6715 871.771 59.9739 871.771 59.0769Z",
    fill: "url(#paint46_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.921 63.8608C944.918 63.8608 945.815 64.4588 946.214 65.3557H987.674L1015.48 93.162H1419.32L1459.58 133.426L1458.19 134.822L1418.42 95.0556H1014.68L986.876 67.2494H946.214C945.815 68.1463 944.918 68.844 943.921 68.844C942.526 68.844 941.43 67.7477 941.43 66.3524C941.43 64.9571 942.526 63.8608 943.921 63.8608Z",
    fill: "url(#paint47_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.038 193.922C910.035 193.922 910.932 194.52 911.331 195.417H1018.77L1051.26 162.927L1457.79 162.927V164.92H1052.06L1019.67 197.51H911.331C910.932 198.407 910.035 199.005 909.038 199.005C907.643 199.005 906.547 197.909 906.547 196.514C906.547 195.118 907.643 193.922 909.038 193.922Z",
    fill: "url(#paint48_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.961 230.001C932.961 231.496 934.157 232.692 935.652 232.692C936.748 232.692 937.745 231.994 938.143 230.997H1441.32L1459.26 213.058L1457.87 211.663L1440.53 229.004H938.143C937.745 228.007 936.748 227.409 935.652 227.409C934.157 227.31 932.961 228.506 932.961 230.001ZM934.456 230.001C934.456 229.403 934.954 228.805 935.652 228.805C936.25 228.805 936.848 229.303 936.848 230.001C936.848 230.599 936.35 231.197 935.652 231.197C935.054 231.197 934.456 230.698 934.456 230.001Z",
    fill: "url(#paint49_linear_1576_69345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.555 100.936C847.555 102.132 848.551 103.128 849.747 103.128C850.844 103.128 851.741 102.331 851.94 101.334H928.283L937.252 110.304H1453.49C1453.69 111.301 1454.59 112.098 1455.68 112.098C1456.88 112.098 1457.87 111.102 1457.87 109.906C1457.87 108.71 1456.88 107.713 1455.68 107.713C1454.59 107.713 1453.69 108.411 1453.49 109.407H937.751L928.781 100.438H852.04C851.84 99.4409 850.943 98.6436 849.847 98.6436C848.551 98.6436 847.555 99.6402 847.555 100.936ZM1454.49 109.906C1454.49 109.208 1455.08 108.71 1455.68 108.71C1456.38 108.71 1456.88 109.308 1456.88 109.906C1456.88 110.603 1456.28 111.102 1455.68 111.102C1455.08 111.201 1454.49 110.603 1454.49 109.906ZM848.551 100.936C848.551 100.238 849.149 99.7398 849.747 99.7398C850.345 99.7398 850.943 100.338 850.943 100.936C850.943 101.633 850.345 102.132 849.747 102.132C849.149 102.132 848.551 101.633 848.551 100.936Z",
    fill: "url(#paint50_linear_1576_69345)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1576_69345",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1576_69345",
    transform: "scale(0.0526316)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_1576_69345",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1576_69345",
    transform: "scale(0.0526316)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_1576_69345",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_1576_69345",
    transform: "scale(0.0526316 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_1576_69345",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_1576_69345",
    transform: "scale(0.0526316 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_1576_69345",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_1576_69345",
    transform: "scale(0.0555556 0.0588235)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5_1576_69345",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_1576_69345",
    transform: "scale(0.0625 0.0588235)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1576_69345",
    x1: 720.128,
    y1: 54.8966,
    x2: 720.128,
    y2: 233.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00507D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#2588C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#0090E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A0FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1576_69345",
    x1: 720.135,
    y1: 54.8993,
    x2: 720.135,
    y2: 233.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29348B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4345,
    stopColor: "#1682B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8188,
    stopColor: "#06C1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1576_69345",
    x1: 720.071,
    y1: -36.382,
    x2: 720.071,
    y2: 130.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#0090E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#2588C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00507D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1576_69345",
    x1: 601.023,
    y1: 257.657,
    x2: -17.4098,
    y2: 257.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1576_69345",
    x1: 500.656,
    y1: 193.623,
    x2: 307.607,
    y2: 193.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1576_69345",
    x1: 500.656,
    y1: 193.623,
    x2: 307.607,
    y2: 193.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1576_69345",
    x1: 500.656,
    y1: 193.623,
    x2: -17.7891,
    y2: 193.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1576_69345",
    x1: 560.164,
    y1: 144.738,
    x2: -17.2737,
    y2: 144.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1576_69345",
    x1: 484.617,
    y1: 132.131,
    x2: -18.7075,
    y2: 132.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1576_69345",
    x1: 524.672,
    y1: 104.873,
    x2: -17.7927,
    y2: 104.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1576_69345",
    x1: 533.25,
    y1: 98.6933,
    x2: 199.475,
    y2: 98.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1576_69345",
    x1: 533.25,
    y1: 98.6933,
    x2: -18.5247,
    y2: 98.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1576_69345",
    x1: 600.625,
    y1: 135.42,
    x2: 313.294,
    y2: 135.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1576_69345",
    x1: 600.625,
    y1: 135.42,
    x2: 313.294,
    y2: 135.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1576_69345",
    x1: 600.539,
    y1: 135.502,
    x2: -17.7924,
    y2: 135.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1576_69345",
    x1: 607,
    y1: 38.895,
    x2: -17.4612,
    y2: 38.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1576_69345",
    x1: 599.023,
    y1: 173.591,
    x2: -17.7891,
    y2: 173.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1576_69345",
    x1: 508.727,
    y1: 181.614,
    x2: 415.142,
    y2: 181.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1576_69345",
    x1: 508.727,
    y1: 181.614,
    x2: 415.142,
    y2: 181.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1576_69345",
    x1: 534.742,
    y1: 213.207,
    x2: -19.0796,
    y2: 213.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1576_69345",
    x1: 450.734,
    y1: 230.387,
    x2: -17.6026,
    y2: 230.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1576_69345",
    x1: 491.789,
    y1: 202.493,
    x2: -17.7891,
    y2: 202.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1576_69345",
    x1: 571.219,
    y1: 64.7578,
    x2: -18.2929,
    y2: 64.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1576_69345",
    x1: 498.57,
    y1: 99.3412,
    x2: -19.5808,
    y2: 99.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1576_69345",
    x1: 533.453,
    y1: 180.966,
    x2: -17.7891,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1576_69345",
    x1: 507.039,
    y1: 222.177,
    x2: -19.2621,
    y2: 222.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1576_69345",
    x1: 592.445,
    y1: 105.371,
    x2: -17.8749,
    y2: 105.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1576_69345",
    x1: 838.977,
    y1: 257.657,
    x2: 1457.41,
    y2: 257.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1576_69345",
    x1: 939.344,
    y1: 193.623,
    x2: 1132.39,
    y2: 193.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1576_69345",
    x1: 939.344,
    y1: 193.623,
    x2: 1132.39,
    y2: 193.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1576_69345",
    x1: 939.344,
    y1: 193.623,
    x2: 1457.79,
    y2: 193.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1576_69345",
    x1: 879.836,
    y1: 144.738,
    x2: 1457.27,
    y2: 144.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1576_69345",
    x1: 955.383,
    y1: 132.131,
    x2: 1458.71,
    y2: 132.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1576_69345",
    x1: 915.328,
    y1: 104.873,
    x2: 1457.79,
    y2: 104.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1576_69345",
    x1: 906.75,
    y1: 98.6933,
    x2: 1240.52,
    y2: 98.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1576_69345",
    x1: 906.75,
    y1: 98.6933,
    x2: 1458.52,
    y2: 98.6933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1576_69345",
    x1: 839.375,
    y1: 135.42,
    x2: 1126.71,
    y2: 135.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1576_69345",
    x1: 839.375,
    y1: 135.42,
    x2: 1126.71,
    y2: 135.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1576_69345",
    x1: 839.461,
    y1: 135.502,
    x2: 1457.79,
    y2: 135.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1576_69345",
    x1: 833,
    y1: 38.895,
    x2: 1457.46,
    y2: 38.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1576_69345",
    x1: 840.977,
    y1: 173.591,
    x2: 1457.79,
    y2: 173.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1576_69345",
    x1: 931.273,
    y1: 181.614,
    x2: 1024.86,
    y2: 181.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1576_69345",
    x1: 931.273,
    y1: 181.614,
    x2: 1024.86,
    y2: 181.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1576_69345",
    x1: 905.258,
    y1: 213.207,
    x2: 1459.08,
    y2: 213.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1576_69345",
    x1: 989.266,
    y1: 230.387,
    x2: 1457.6,
    y2: 230.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1576_69345",
    x1: 948.211,
    y1: 202.493,
    x2: 1457.79,
    y2: 202.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1576_69345",
    x1: 868.781,
    y1: 64.7578,
    x2: 1458.29,
    y2: 64.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1576_69345",
    x1: 941.43,
    y1: 99.3412,
    x2: 1459.58,
    y2: 99.3412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1576_69345",
    x1: 906.547,
    y1: 180.966,
    x2: 1457.79,
    y2: 180.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1576_69345",
    x1: 932.961,
    y1: 222.177,
    x2: 1459.26,
    y2: 222.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1576_69345",
    x1: 847.555,
    y1: 105.371,
    x2: 1457.87,
    y2: 105.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1576_69345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 292,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1576_69345",
    width: 19,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUtJREFUeNrMlMtOwzAQReMkpRQEKoiHhIT4/w+DBaKhlFJoQ2xm0DEa7Bg2LLB0ZNmJr69nxq6q/9rc2GQIwZlvsQ+xd86FX8WMiNJAjZDihYE+E21HxBvmp8KeMEFIRXphSz/I5t4KtomrmsUz4QhmiO2EjbCi3xrHmTPHeF+YC5fCuXDMAhXocB6dqjsX3bWJKx0fCKfCtXAjnLGZOrojXjvoGWfO4hFV7ES4QuyC7x1u7jl6y5piAtKYzcEhdEhimqR0wphYZWrKlkJF/x7LwtZdyZknDhrspfBgftZjPgprMjlYoVQsCr2w6Jb5Bf0Tcx2bfQv+l5imVgvQuIqOVsRP2ytCCzb8FBstWlM7b4w1Ps/cgsoU7YZ/smOmd7Mmow1ZnZj0R+d9vJ/iyv/4apjLXqd1hKAvvRyu9DYhmj8zhefnz9uHAAMA1FmQd8BGYDEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1576_69345",
    width: 19,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUZJREFUeNqslMtOwzAQRW3jttAClQoLNsD/fxcCsSjvtoQ2iZkRx5WTOFSRaukocuy5c8cvY47Y7H+DIYTOuLU2DBJDRHGtOSpU6zcnajNCDpETwYNDqEzoiPqMIw0cCRNhKpwhrMGFsOG7EyqSdMVwqoGnwqWwEObCGDdfwjus//KHvTvf42omXAu3wg39rbAUngipE0LOWRSb4upOuMellvXMnAJ+1HF0lyvTU+aFcIWzBWV61mxJqSscV21nNvk6xuImzChH1+mcZHGXTW4DQusslWSN5cSj0djBPjGTBBSU8MJuloxp/4NSdyTtFauZtCHwgX9zxlXoUXij5IagT++ctCi2ZpHVzScHV9u38EqivbvOOUvKrCjTJAd1TH+LSLwFjfU7dDdH4FrLEK+SuqqHvBous67Zl2Pwe3boTTta+xVgAGYdmjO17Z8oAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_1576_69345",
    width: 19,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAR1JREFUeNq0lG1LwzAURpt286WK4tBviuD//1l+GqNOp1udXeNz4aRkVwqCNXCgyZqT5ybpimLCFsZ+iDEG914cOiHEX8mQGCXk7/RgsuilwYmSoBJzqLJknfiCg4lzYXCJkuRM1OJCnLKAiVrxIbbik7FBOHMpK0RX4lYsxCXje/EmVqIhaSq7GGSkKklVI3oUDwhtfCeWJO0pteP54JPlshtxL57EnTgR76S2El/FhgWChbFSZ+4wSybWlLpAZmnOmXzN85z3jyZP1nyyno3estkNm5/KbChxx571Y7K0qSZ6Ec+c8NodwJKFWjY+Hl0N66jlshULbEauxhpZ9+NqpHvLSi39DtnYpd37Mv/nc5r8Q//rX9Ck7VuAAQCkV4ecOJxYAgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_1576_69345",
    width: 19,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATVJREFUeNqslE1PwkAQhpm6JYpG1IPRgwf//9/SeBAQ/EChtOtM8mwyLu3KgU3etGU7D+/MznQ0OuKS0maMsXdfROLBMCCmCvnVoZhDpQAJqHZAgzSotWcFdik+9Dg9AXCmmnCt2d+q1ujHoNEc4DBkrioCz1VT1Y3qWnVqrwBZqOZ5yrmz5MoCL1X3qgeuFwStVE+8u0vpJnchq1UAdgXkEeCU4Bku3tGa1NshZ2PStPRuVXc4bQDNqeU4P+lqoF18WyTJf03rnUV39HZSH6olLjf8vqBuKb1uD2bFs0XuG0CvDjRxsGfVG8DGA3NnO1wtSc1AL9TH/ugT4MzD9vrM9c2WILv/5nQDzwb/ck3bph4bGqfKTUENSAhqS+MkhSHvG/R48KAXPj/yJ52BT9BR168AAwDYho+SK6MU3wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_1576_69345",
    width: 18,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAARCAYAAADQWvz5AAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASdJREFUeNqslN1OwzAMhecujGkIxAWCCS73/o+1CQ0uBmg/dE284+1E8qJmXLBIn+o29qntuJXBhaWqdpF8KyJVX/kjuNzXmqhURIwGDH1GIIJE+0xMekRMIIARCXTpQEu6LJjFQpGd8NkY3IMH2rZ24Bv80N77ckPRg4ZZmMgLmIJH7q3AO+3EMmMODEVZ1pNbBr+CGXim75Iv+mVGVmJC7LG8UJQ1ZEZ34Am8UdDWDfii4Ii+HeM09IxDwyDrzYSiA9pj7jXliYeeOUlspKW/AWvubVyTk5upMyF1c9Iy+BPM3eks+WxNn+jiTkLWLD11PLKZdkILvvmjOLUVfWJtjvKxtpwVW9vKHLX07e2Rugne0XF7YbLV9+n639pVv/7//I8OAgwAMI+DVgNyOisAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_1576_69345",
    width: 16,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARNJREFUeNrMk0uPAUEUhft2lxlCGCMSK7H1/3+PxELEBglmPPpRzpVT7apgM5up5EtXU+fcV3WS/HFJ/IP3Xp7878NTRF4bUKykIONexZXhwUQisQod+ARN7tXgDE4gB4U1cVFkfW+DL9AHLVCCHdjyqYalVxFMnKkgZWQVjkmPUVdgTrMilFJnwJUx4jeYgCkYgAvosow9OBqT2iDU/wE6FI7AkMJfmrQYKGh8+makFVMuzRjDufqsiwQFo63BAvywhBUbeI4NnbkoJetT8QwcOJGCE1iyBznP+2cZ6Kw3FK3Zk4rGe5rmNgPhPQj7jDRIarLLSSjhdg/sTbQNkqhZPibcxPhbePeh3dMWSf7PugowABFIcJ5cDlCaAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerSecurity);
export default __webpack_public_path__ + "static/media/BannerSecurity.2f4b7ce621e4fb2239399df2b5211da5.svg";
export { ForwardRef as ReactComponent };